/* DRIVE IQ START DRIVE - V26 SEARCH IQ + EVIDENCE-BASED HIGHWAY IQ; based on V25.6 GARAGE THEME AUTHORITY FIX + V25.5 AMERICAN MUSCLE MIDNIGHT OVERRIDE FIX + V25.4 AMERICAN MUSCLE GARAGE SYNC + V25.3 CARBON RS GARAGE SYNC + V25.2 ROUTE OPTIONS MINIMIZE + V25.1 ROUTE CHOOSER CLEANUP + V25 MULTI-ROUTE MAP PREVIEW + V24E FIVE-TRIP NATIVE URL STOREKIT FIX + V23 MAPBOX SPEED LIMIT AUTHORITY + V21 GLOBAL EXACT BUSINESS RECOVERY + V20 ROUTE EXPLANATIONS + V19 REAL ROUTE OPTIONS + V18 THEME SYNC + V13 START TRIP RELIABILITY + V12 ROUTE OVERVIEW + V11 CITY SEARCH
   Pro Driver Business + City Authority: Google Places first, city/locality recovery,
   business-name/locality recovery, spelling/name variants, stale/faraway suppression,
   Geoapify city/geocode fallback.
   Preserves Mapbox map, Geoapify routing, route camera, GPS and Drive Mode handoff.
   Drop-in replacement JS for Start Drive page.
   ES5-safe. No optional chaining. No arrow functions. No template literals.

   Required HTML ids:
   - diqMap
   - diqDestInput
   - diqResults
   - diqRouteNow
   - diqLockGps
   - diqClearRoute
   Optional ids supported:
   - diqStartDrive, diqPillStatus, diqPillGps, diqPillMode, diqSubline, diqToast
   - diqRouteScore, diqRouteScoreSub, diqArrivalIntel, diqArrivalSub

   Token lookup order:
   - window.DRIVE_IQ_GOOGLE_PLACES_KEY / window.DRIVE_IQ_GOOGLE_MAPS_KEY
   - window.SLX_GOOGLE_PLACES_KEY / window.SLX_GOOGLE_MAPS_KEY
   - window.DRIVE_IQ_MAPBOX_TOKEN / window.DRIVE_IQ_GEOAPIFY_KEY
   - window.SLX_MAPBOX_TOKEN / window.SLX_GEOAPIFY_KEY
   - #diqApp / #slxApp / #diqMap data-google-places-key, data-mapbox-token, data-geoapify-key
*/

/* =====================================================================
   GOOGLE PLACES KEY — PASTE YOUR KEY ON THE LINE BELOW
   Example:
   window.DRIVE_IQ_GOOGLE_PLACES_KEY = "AIza...";
===================================================================== */
window.DRIVE_IQ_GOOGLE_PLACES_KEY = "AIzaSyD1aJx1vi9TUE6I1bjt50prHMoZcDALGwY";

(function(){
"use strict";

if(window.__DRIVE_IQ_START_DRIVE_V7_ROUTE_OVERVIEW_FIX__) return;
window.__DRIVE_IQ_START_DRIVE_V7_ROUTE_OVERVIEW_FIX__ = true;

var DRIVE_MODE_URL = "/pages/drive-mode";
var map = null;
var mapLoaded = false;
var gpsWatchId = null;
var lastFix = null;
var dest = null;
var routeGeo = null;
var routeReady = false;

/* V19 REAL ROUTE OPTIONS
   Up to four genuinely distinct Geoapify routes. The active choice remains
   routeGeo so Drive Mode receives the same route shape it already expects. */
var routeOptions = [];
var selectedRouteIndex = 0;
var routeRequestGeneration = 0;
/* Rural Road Recovery: presentation-only metadata, never an off-road guidance leg. */
var ruralRoadRecovery = null;

/* V25 MULTI-ROUTE MAP PREVIEW
   All real route choices can be shown together before Start Drive.
   The selected route remains routeGeo and is still the only route handed to
   Drive Mode. Alternate map lines and ETA badges are presentation-only. */
var routeEtaMarkers = [];
var routeOptionMapClickBound = false;
var routeOptionsCollapsed = false;

var searchTimer = null;
var lastSearchRun = 0;
var pendingStartAfterRoute = false;
var googlePlacesLoadPromise = null;
var googlePlacesLibrary = null;

/* V12 ROUTE OVERVIEW CAMERA AUTHORITY */
var routeOverviewGeneration = 0;
var routeOverviewLockUntil = 0;
var routeOverviewLastFitAt = 0;

var LS = {
  LAST_FIX:"diq_last_gps_v1",
  DEST:"diq_dest_v1",
  ROUTE_GEO:"diq_route_geo_v1",
  ROUTE_INTEL:"diq_route_intel_v1",
  ROUTE_OPTIONS:"diq_route_options_v1",
  SELECTED_ROUTE_KIND:"diq_selected_route_kind_v1",
  DRIVE_ON:"diq_drive_on_v1",
  ACTIVE_DRIVE_ID:"diq_active_drive_id_v1",
  DRIVE_PAYLOAD:"diq_drive_payload_v1",
  COMPLETED_TRIPS:"diq_completed_trips_v1",
  PLUS_ACTIVE:"diq_plus_active_v1",
  FOUNDING_DRIVER:"diq_founding_driver_v1",
  ACCESS_TIER:"diq_access_tier_v1",

  /* V18 shared appearance authority — same keys as My Drive IQ / Drive Mode. */
  GARAGE_SKIN:"diq_garage_skin_v1",
  NATIVE_SKIN:"diq_native_active_skin_v1",
  ACTIVE_SKIN:"diq_active_skin_v1",
  SKIN_FALLBACK_1:"driveiq_skin",
  SKIN_FALLBACK_2:"driveiq_theme",
  SKIN_FALLBACK_3:"diq_theme_v1"
};

function byId(id){ return document.getElementById(id); }
function finite(v){ return typeof v === "number" && isFinite(v); }
function clean(v){ return String(v || "").replace(/\s+/g," ").trim(); }
function num(v){ var n = Number(v); return finite(n) ? n : null; }

function readDataAttr(id, name){
  var el = byId(id);
  if(!el) return "";
  return String(el.getAttribute(name) || "");
}

function getMapboxToken(){
  return clean(window.DRIVE_IQ_MAPBOX_TOKEN || window.SLX_MAPBOX_TOKEN || readDataAttr("diqApp","data-mapbox-token") || readDataAttr("slxApp","data-mapbox-token") || readDataAttr("diqMap","data-mapbox-token"));
}

function getGeoapifyKey(){
  return clean(window.DRIVE_IQ_GEOAPIFY_KEY || window.SLX_GEOAPIFY_KEY || readDataAttr("diqApp","data-geoapify-key") || readDataAttr("slxApp","data-geoapify-key") || readDataAttr("diqMap","data-geoapify-key"));
}

function getGooglePlacesKey(){
  return clean(
    window.DRIVE_IQ_GOOGLE_PLACES_KEY ||
    window.DRIVE_IQ_GOOGLE_MAPS_KEY ||
    window.SLX_GOOGLE_PLACES_KEY ||
    window.SLX_GOOGLE_MAPS_KEY ||
    readDataAttr("diqApp","data-google-places-key") ||
    readDataAttr("diqApp","data-google-maps-key") ||
    readDataAttr("slxApp","data-google-places-key") ||
    readDataAttr("slxApp","data-google-maps-key") ||
    readDataAttr("diqMap","data-google-places-key") ||
    readDataAttr("diqMap","data-google-maps-key")
  );
}

function ensureGooglePlaces(){
  var key = getGooglePlacesKey();

  if(googlePlacesLibrary && googlePlacesLibrary.Place){
    return Promise.resolve(googlePlacesLibrary);
  }

  if(!key) return Promise.resolve(null);
  if(googlePlacesLoadPromise) return googlePlacesLoadPromise;

  googlePlacesLoadPromise = new Promise(function(resolve){
    var finished = false;
    var attempts = 0;
    var maxAttempts = 18;

    function done(lib){
      if(finished) return;
      finished = true;
      googlePlacesLibrary = lib || null;

      /* Never poison the whole page session with one transient bootstrap miss. */
      if(!googlePlacesLibrary){
        googlePlacesLoadPromise = null;
      }

      resolve(googlePlacesLibrary);
    }

    function tryImport(){
      attempts += 1;

      try{
        if(window.google &&
           google.maps &&
           typeof google.maps.importLibrary === "function"){

          google.maps.importLibrary("places").then(function(lib){
            if(lib && (lib.Place || (window.google.maps.places && window.google.maps.places.Place))){
              done(lib);
            }else if(attempts < maxAttempts){
              window.setTimeout(tryImport,120);
            }else{
              done(null);
            }
          }).catch(function(){
            if(attempts < maxAttempts){
              window.setTimeout(tryImport,160);
            }else{
              done(null);
            }
          });

          return;
        }
      }catch(e1){}

      if(attempts < maxAttempts){
        window.setTimeout(tryImport,120);
      }else{
        done(null);
      }
    }

    try{
      if(window.google && google.maps){
        tryImport();
        return;
      }

      var existing = document.querySelector('script[data-drive-iq-google-places="1"]');
      if(existing){
        tryImport();
        return;
      }

      var script = document.createElement("script");
      script.setAttribute("data-drive-iq-google-places","1");
      script.src =
        "https://maps.googleapis.com/maps/api/js?key=" +
        encodeURIComponent(key) +
        "&libraries=places&v=weekly&loading=async";
      script.async = true;
      script.defer = true;
      script.onload = tryImport;
      script.onerror = function(){ done(null); };
      document.head.appendChild(script);

      window.setTimeout(tryImport,180);

    }catch(e2){
      done(null);
    }
  });

  return googlePlacesLoadPromise;
}

function lsGet(k){ try{ return localStorage.getItem(k); }catch(e){ return null; } }
function lsSet(k,v){ try{ localStorage.setItem(k,String(v)); }catch(e){} }
function lsRemove(k){ try{ localStorage.removeItem(k); }catch(e){} }
function lsGetJSON(k){ try{ return JSON.parse(String(localStorage.getItem(k) || "")); }catch(e){ return null; } }
function lsSetJSON(k,v){ try{ localStorage.setItem(k,JSON.stringify(v)); }catch(e){} }


/* =====================================================================
   V18 START DRIVE THEME AUTHORITY
   One saved My Drive IQ skin now paints:
   - Start Drive shell
   - route / route glow
   - GPS pin
   - destination pin
   - active controls / cards through CSS variables

   Presentation only. Never changes map style, route geometry, GPS, route
   overview camera, search, Drive Mode handoff, or drive-session state.
===================================================================== */
var DIQ_SKIN_ALLOW = {
  carbon_rs:1,american_muscle:1,platinum_gt:1,cockpit:1,aurora:1,sunset:1,coastal:1,midnight_luxe:1,
  volt:1,forest:1,autumn:1,holiday:1
};

var START_DRIVE_SKINS = {
  platinum_gt:{
    /* Platinum GT: pearl white, brushed platinum and champagne-gold route. */
    accent:"#C8A96B",accent2:"#A48A59",accent3:"#F7F3EA",
    routeA:"#F2DDAA",routeB:"#C8A96B",routeC:"#FFF2D2",
    routeGlow:"#977D4D",
    glow:"rgba(200,169,107,.27)",gps:"#F4F1EA",gpsRing:"#C8A96B",
    dest:"#D8C29A",surface:"#F4F1EC",surface2:"#D9DDE2",
    text:"#1E2228",muted:"rgba(30,34,40,.66)"
  },
  american_muscle:{
    /* American Muscle: graphite instruments, performance red, crisp white. */
    accent:"#F04B51",accent2:"#9B1728",accent3:"#F4F0F0",
    routeA:"#FF5159",routeB:"#C31F36",routeC:"#FF9C9E",
    routeGlow:"#681321",
    glow:"rgba(240,75,81,.32)",gps:"#E7E9ED",gpsRing:"#F04B51",
    dest:"#FF666D",surface:"#17191F",surface2:"#08090D",
    text:"#FAFAFC",muted:"rgba(235,236,240,.72)"
  },
  carbon_rs:{
    /* Carbon RS Silver Edition: graphite, brushed silver and racing red. */
    accent:"#E54854",accent2:"#A7192C",accent3:"#E5E9EF",
    routeA:"#FF5361",routeB:"#D8243D",routeC:"#F08B96",
    routeGlow:"#750F24",
    glow:"rgba(229,72,84,.30)",gps:"#C6CFD8",gpsRing:"#E54854",
    dest:"#F15B68",surface:"#171B22",surface2:"#080B11",
    text:"#F5F6F8",muted:"rgba(230,234,240,.72)"
  },
  cockpit:{
    accent:"#00F5FF",accent2:"#28FFBE",accent3:"#FFFFFF",
    routeA:"#00F5FF",routeB:"#28FFBE",routeC:"#BFFBFF",
    routeGlow:"#073B4C",
    glow:"rgba(0,245,255,.38)",gps:"#28FFBE",gpsRing:"#B6FFEB",
    dest:"#00F5FF",surface:"#06131C",surface2:"#020812",
    text:"#FFFFFF",muted:"rgba(255,255,255,.68)"
  },
  aurora:{
    accent:"#35D9C4",accent2:"#8F79FF",accent3:"#BFF7FF",
    routeA:"#35D9C4",routeB:"#8F79FF",routeC:"#BFF7FF",
    routeGlow:"#6D55C9",
    glow:"rgba(53,217,196,.38)",gps:"#35D9C4",gpsRing:"#8F79FF",
    dest:"#BFF7FF",surface:"#081922",surface2:"#050A14",
    text:"#FFFFFF",muted:"rgba(255,255,255,.70)"
  },
  sunset:{
    accent:"#D66B38",accent2:"#8F3F62",accent3:"#F3C66A",
    routeA:"#D66B38",routeB:"#E18A48",routeC:"#F3C66A",
    routeGlow:"#5B1738",
    glow:"rgba(214,107,56,.38)",gps:"#D66B38",gpsRing:"#8F3F62",
    dest:"#F3C66A",surface:"#261022",surface2:"#0D0712",
    text:"#FFFFFF",muted:"rgba(255,245,235,.72)"
  },
  coastal:{
    accent:"#27D8E6",accent2:"#6AB8CF",accent3:"#E7D9A8",
    routeA:"#27D8E6",routeB:"#6AB8CF",routeC:"#E7D9A8",
    routeGlow:"#075D7A",
    glow:"rgba(39,216,230,.36)",gps:"#27D8E6",gpsRing:"#6AB8CF",
    dest:"#E7D9A8",surface:"#063042",surface2:"#02101A",
    text:"#FFFFFF",muted:"rgba(235,252,255,.72)"
  },
  midnight_luxe:{
    accent:"#D8B86A",accent2:"#604C8A",accent3:"#F2DDB0",
    routeA:"#D8B86A",routeB:"#C79B62",routeC:"#F2DDB0",
    routeGlow:"#3A285F",
    glow:"rgba(216,184,106,.34)",gps:"#D8B86A",gpsRing:"#604C8A",
    dest:"#F2DDB0",surface:"#0A1124",surface2:"#010309",
    text:"#FFFFFF",muted:"rgba(245,240,255,.70)"
  },
  volt:{
    accent:"#9FE43B",accent2:"#3DE9D5",accent3:"#DFFFB4",
    routeA:"#9FE43B",routeB:"#3DE9D5",routeC:"#DFFFB4",
    routeGlow:"#176B55",
    glow:"rgba(159,228,59,.34)",gps:"#9FE43B",gpsRing:"#3DE9D5",
    dest:"#3DE9D5",surface:"#051F16",surface2:"#010604",
    text:"#FFFFFF",muted:"rgba(245,255,224,.72)"
  },
  forest:{
    accent:"#C58B49",accent2:"#315F3B",accent3:"#D8C09A",
    routeA:"#C58B49",routeB:"#A7743E",routeC:"#D8C09A",
    routeGlow:"#315F3B",
    glow:"rgba(197,139,73,.32)",gps:"#6E9B55",gpsRing:"#C58B49",
    dest:"#6E9B55",surface:"#0B2213",surface2:"#030805",
    text:"#FFFFFF",muted:"rgba(235,255,241,.70)"
  },
  autumn:{
    accent:"#C7A14A",accent2:"#9E4C24",accent3:"#D9B36A",
    routeA:"#C7A14A",routeB:"#B06C32",routeC:"#D9B36A",
    routeGlow:"#7A351D",
    glow:"rgba(199,161,74,.34)",gps:"#C7A14A",gpsRing:"#9E4C24",
    dest:"#9E4C24",surface:"#2B120A",surface2:"#090403",
    text:"#FFFFFF",muted:"rgba(255,244,226,.72)"
  },
  holiday:{
    accent:"#D05A2C",accent2:"#6F43A2",accent3:"#D5A13F",
    routeA:"#D05A2C",routeB:"#E27A35",routeC:"#D5A13F",
    routeGlow:"#5B2A86",
    glow:"rgba(111,67,162,.34)",gps:"#D05A2C",gpsRing:"#6F43A2",
    dest:"#D5A13F",surface:"#190926",surface2:"#030205",
    text:"#FFFFFF",muted:"rgba(248,240,255,.72)"
  }
};

var activeSkin = "cockpit";

function normalizeSkin(v){
  v = clean(v).toLowerCase().replace(/[\s-]+/g,"_");
  if(v === "midnight" || v === "midnightluxe") v = "midnight_luxe";
  if(v === "americanmuscle" || v === "muscle" || v === "muscle_gt") v = "american_muscle";
  if(v === "volt_gt" || v === "voltgt") v = "volt";
  if(v === "carbonrs" || v === "carbon_rs_silver") v = "carbon_rs";
  return DIQ_SKIN_ALLOW[v] ? v : "cockpit";
}

function readSkin(){
  var v = "";
  /* V25.7: Garage is the explicit user selection and MUST win over
     older active/native mirrors (which can still contain Carbon RS). */
  v = lsGet(LS.GARAGE_SKIN) ||
      lsGet(LS.ACTIVE_SKIN) ||
      lsGet(LS.NATIVE_SKIN) ||
      lsGet(LS.SKIN_FALLBACK_1) ||
      lsGet(LS.SKIN_FALLBACK_2) ||
      lsGet(LS.SKIN_FALLBACK_3) ||
      "cockpit";
  return normalizeSkin(v);
}

function startPalette(){
  return START_DRIVE_SKINS[activeSkin] || START_DRIVE_SKINS.cockpit;
}

function writeSkinDom(skin){
  var root;
  skin = normalizeSkin(skin);
  try{ document.documentElement.setAttribute("data-diq-skin",skin); }catch(e1){}
  try{ document.body.setAttribute("data-diq-skin",skin); }catch(e2){}

  try{
    root = byId("diqApp") || byId("slxApp") || byId("diqPage") || byId("startDrivePage");
    if(root) root.setAttribute("data-diq-skin",skin);
  }catch(e3){}

  try{ window.DriveIQActiveSkin = skin; }catch(e4){}
}

function ensureStartDriveThemeCss(){
  var style;
  if(byId("diqStartDriveThemeV18")) return;

  style = document.createElement("style");
  style.id = "diqStartDriveThemeV18";
  style.type = "text/css";
  style.textContent =
    'html[data-diq-skin],body[data-diq-skin]{'+
      '--diq-accent:'+startPalette().accent+';'+
      '--diq-accent-2:'+startPalette().accent2+';'+
      '--diq-accent-3:'+startPalette().accent3+';'+
      '--diq-surface:'+startPalette().surface+';'+
      '--diq-surface-2:'+startPalette().surface2+';'+
      '--diq-text:'+startPalette().text+';'+
      '--diq-muted:'+startPalette().muted+';'+
    '}'+
    'body[data-diq-skin] #diqDestInput{'+
      'border-color:color-mix(in srgb,var(--diq-accent) 42%,transparent)!important;'+
      'box-shadow:0 0 0 1px color-mix(in srgb,var(--diq-accent) 14%,transparent),0 12px 30px rgba(0,0,0,.22)!important;'+
    '}'+
    'body[data-diq-skin] #diqDestInput:focus{'+
      'border-color:var(--diq-accent)!important;'+
      'box-shadow:0 0 0 3px color-mix(in srgb,var(--diq-accent) 18%,transparent),0 14px 34px rgba(0,0,0,.26)!important;'+
    '}'+
    'body[data-diq-skin] .diqSearchCard,'+
    'body[data-diq-skin] .diqRouteCard{'+
      'border-color:color-mix(in srgb,var(--diq-accent) 26%,transparent)!important;'+
      'box-shadow:0 20px 54px rgba(0,0,0,.30),0 0 28px color-mix(in srgb,var(--diq-accent) 10%,transparent)!important;'+
    '}'+
    'body[data-diq-skin] .diqRouteCard.routeReady,'+
    'body[data-diq-skin] .diqSearchCard.routeActive{'+
      'border-color:color-mix(in srgb,var(--diq-accent) 52%,transparent)!important;'+
      'box-shadow:0 20px 54px rgba(0,0,0,.32),0 0 34px color-mix(in srgb,var(--diq-accent) 18%,transparent)!important;'+
    '}'+
    'body[data-diq-skin] #diqRouteNow,'+
    'body[data-diq-skin] #diqStartDrive{'+
      'border-color:color-mix(in srgb,var(--diq-accent) 52%,transparent)!important;'+
      'box-shadow:0 0 28px color-mix(in srgb,var(--diq-accent) 20%,transparent)!important;'+
    '}'+
    'body[data-diq-skin] #diqStartDrive{'+
      'background:linear-gradient(135deg,var(--diq-accent-2),var(--diq-accent))!important;'+
    '}'+
    'body[data-diq-skin] #diqResults{'+
      'border-color:color-mix(in srgb,var(--diq-accent) 24%,transparent)!important;'+
    '}'+
    'body[data-diq-skin] .diqResultItem:hover,'+
    'body[data-diq-skin] .diqResultItem:focus{'+
      'border-color:color-mix(in srgb,var(--diq-accent) 42%,transparent)!important;'+
    '}';

  try{ document.head.appendChild(style); }catch(e){}
}

function refreshStartDriveThemeCssVars(){
  var p = startPalette(), root = document.documentElement;
  try{
    root.style.setProperty("--diq-accent",p.accent);
    root.style.setProperty("--diq-accent-2",p.accent2);
    root.style.setProperty("--diq-accent-3",p.accent3);
    root.style.setProperty("--diq-surface",p.surface);
    root.style.setProperty("--diq-surface-2",p.surface2);
    root.style.setProperty("--diq-text",p.text);
    root.style.setProperty("--diq-muted",p.muted);
  }catch(e){}
}

function paintStartDriveMapTheme(){
  var p = startPalette();
  if(!mapLoaded || !map) return;

  try{
    if(map.getLayer("diq-gps-halo")) map.setPaintProperty("diq-gps-halo","circle-color",p.gps);
    if(map.getLayer("diq-gps-dot")) map.setPaintProperty("diq-gps-dot","circle-color",p.gps);
    if(map.getLayer("diq-gps-ring")) map.setPaintProperty("diq-gps-ring","circle-stroke-color",p.gpsRing);

    if(map.getLayer("diq-dest-halo")) map.setPaintProperty("diq-dest-halo","circle-color",p.dest);
    if(map.getLayer("diq-dest-core")) map.setPaintProperty("diq-dest-core","circle-color",p.dest);
    if(map.getLayer("diq-dest-label")) map.setPaintProperty("diq-dest-label","text-color",p.accent3);

    if(map.getLayer("diq-route-glow")) map.setPaintProperty("diq-route-glow","line-color",p.routeGlow || p.accent);
    if(map.getLayer("diq-route-line")){
      map.setPaintProperty("diq-route-line","line-gradient",[
        "interpolate",["linear"],["line-progress"],
        0,p.routeA,
        0.55,p.routeB,
        1,p.routeC
      ]);
    }
  }catch(e){}
}

function applyStartDriveSkin(next, source){
  activeSkin = normalizeSkin(next || readSkin());
  writeSkinDom(activeSkin);
  ensureStartDriveThemeCss();
  refreshStartDriveThemeCssVars();

  /* V25.5: Legacy DriveIQ.applyTheme does not recognize Signature Cockpits.
     Calling it with american_muscle (or carbon_rs) can silently fall back
     to the previously selected Midnight Luxe theme. Keep Garage selection
     authoritative and let this module paint the route and controls. */
  try{
    if(activeSkin !== "american_muscle" && activeSkin !== "carbon_rs" &&
       activeSkin !== "platinum_gt" &&
       window.DriveIQ && typeof window.DriveIQ.applyTheme === "function"){
      window.DriveIQ.applyTheme(activeSkin);
    }
  }catch(e1){}

  paintStartDriveMapTheme();
  try{
    if(mapLoaded && map && map.getLayer("diq-route-options-lines")){
      map.setPaintProperty("diq-route-options-lines","line-color",startPalette().accent3);
    }
    /* Refresh inline-styled ETA badges without touching route layer order. */
    if(mapLoaded && map && routeOptions && routeOptions.length > 1 && routeReady){
      clearRouteEtaMarkers();
      for(var themeI=0;themeI<routeOptions.length;themeI++){
        var themeOpt=routeOptions[themeI];
        var themeCoord=routeBadgeCoordinate(themeOpt && themeOpt.feature,themeI);
        var themeBadge=themeCoord ? makeRouteEtaBadge(themeOpt,themeI) : null;
        if(!themeBadge) continue;
        try{
          routeEtaMarkers.push(new mapboxgl.Marker({element:themeBadge,anchor:"center"})
            .setLngLat([Number(themeCoord[0]),Number(themeCoord[1])]).addTo(map));
        }catch(themeBadgeErr){}
      }
    }
  }catch(themeMapErr){}

  try{
    window.dispatchEvent(new CustomEvent("driveiq:startdrivethemeapplied",{
      detail:{skin:activeSkin,source:source || "start-drive"}
    }));
  }catch(e2){}

  return activeSkin;
}

/* V25.6: Ignore late legacy theme events that disagree with the saved Garage selection. */
function onStartDriveThemeChange(ev){
  var d = ev && ev.detail ? ev.detail : {};
  var requested = typeof d === "string" ? d : (d.skin || d.theme || d.themeId || d.id);
  var saved = readSkin();
  if(requested && normalizeSkin(requested) !== saved){
    applyStartDriveSkin(saved,"reject-stale-themechange");
    return;
  }
  applyStartDriveSkin(saved,"driveiq:themechange");
}

/* A legacy theme module may change the HTML skin after our initial paint.
   Restore only when attributes actually diverge; this does not touch routing. */
function installStartDriveSkinGuard(){
  if(!window.MutationObserver || window.__diqStartSkinGuardV256) return;
  window.__diqStartSkinGuardV256 = true;
  var observer = new MutationObserver(function(){
    var chosen = readSkin();
    var htmlSkin = document.documentElement.getAttribute("data-diq-skin");
    var bodySkin = document.body && document.body.getAttribute("data-diq-skin");
    if(htmlSkin !== chosen || (document.body && bodySkin !== chosen)){
      applyStartDriveSkin(chosen,"repair-legacy-dom-override");
    }
  });
  observer.observe(document.documentElement,{attributes:true,attributeFilter:["data-diq-skin"]});
  if(document.body) observer.observe(document.body,{attributes:true,attributeFilter:["data-diq-skin"]});
}

function startThemeAuthority(){
  applyStartDriveSkin(readSkin(),"boot-storage");
  window.setTimeout(function(){
    applyStartDriveSkin(readSkin(),"settled-page-load");
  },850);
  installStartDriveSkinGuard();
  window.addEventListener("driveiq:themechange",onStartDriveThemeChange,false);
  window.addEventListener("pageshow",function(){
    applyStartDriveSkin(readSkin(),"pageshow");
  },false);
  window.addEventListener("focus",function(){
    applyStartDriveSkin(readSkin(),"focus");
  },false);
  window.addEventListener("storage",function(ev){
    if(!ev || ev.key === LS.GARAGE_SKIN || ev.key === LS.NATIVE_SKIN ||
       ev.key === LS.ACTIVE_SKIN || ev.key === LS.SKIN_FALLBACK_1 ||
       ev.key === LS.SKIN_FALLBACK_2 || ev.key === LS.SKIN_FALLBACK_3){
      applyStartDriveSkin(readSkin(),"storage");
    }
  },false);
}

function esc(v){
  return String(v == null ? "" : v)
    .replace(/&/g,"&amp;")
    .replace(/</g,"&lt;")
    .replace(/>/g,"&gt;")
    .replace(/\"/g,"&quot;")
    .replace(/'/g,"&#39;");
}

function setText(id, text){ var el = byId(id); if(el) el.textContent = text; }
function setStatus(text, kind){
  var el = byId("diqPillStatus");
  if(el){
    el.className = "diqPill" + (kind ? " " + kind : "");
    el.textContent = text || "Ready";
  }
}
function setGps(text){ setText("diqPillGps", text || "GPS: --"); }
function setMode(text){ setText("diqPillMode", text || "Drive IQ"); }
function setSubline(text){ setText("diqSubline", text || "Search destination - Draw route - Start drive"); }
function toast(text){
  var el = byId("diqToast");
  if(!el) return;
  el.textContent = text || "Ready";
  el.className = "diqToast on";
  window.setTimeout(function(){ el.className = "diqToast"; }, 1400);
}

function emptyFC(){ return { type:"FeatureCollection", features:[] }; }
function pointFC(lng, lat, props){
  return { type:"FeatureCollection", features:[{ type:"Feature", properties:props || {}, geometry:{ type:"Point", coordinates:[Number(lng), Number(lat)] } }] };
}
function routeFC(feature){ return { type:"FeatureCollection", features:[feature] }; }

function miles(lat1,lng1,lat2,lng2){
  var R = 3958.8;
  var dLat = (Number(lat2)-Number(lat1))*Math.PI/180;
  var dLng = (Number(lng2)-Number(lng1))*Math.PI/180;
  var a1 = Number(lat1)*Math.PI/180;
  var a2 = Number(lat2)*Math.PI/180;
  var x = Math.sin(dLat/2)*Math.sin(dLat/2) + Math.sin(dLng/2)*Math.sin(dLng/2)*Math.cos(a1)*Math.cos(a2);
  return R * (2 * Math.atan2(Math.sqrt(x), Math.sqrt(1-x)));
}
function fmtMiles(mi){
  var n = Number(mi);
  if(!finite(n)) return "";
  if(n < 0.1) return "0.1 mi";
  if(n >= 100) return String(Math.round(n)) + " mi";
  return String(Math.round(n*10)/10) + " mi";
}
function fmtTime(seconds){
  var mins = Math.round(Number(seconds || 0) / 60);
  var h, r;
  if(!finite(mins) || mins <= 0) return "--";
  h = Math.floor(mins / 60);
  r = mins % 60;
  if(h <= 0) return String(r) + " min";
  if(r <= 0) return String(h) + " hr";
  return String(h) + " hr " + String(r) + " min";
}

function removeLayer(id){ try{ if(map && map.getLayer(id)) map.removeLayer(id); }catch(e){} }
function removeSource(id){ try{ if(map && map.getSource(id)) map.removeSource(id); }catch(e){} }

function ensureMapSize(){
  var el = byId("diqMap");
  if(el){
    if(!el.style.minHeight) el.style.minHeight = "520px";
    if(!el.style.width) el.style.width = "100%";
  }
  if(map){ try{ map.resize(); }catch(e){} }
}

function ensureGpsSource(){
  var p = startPalette();
  if(!mapLoaded || !map) return;
  try{
    if(!map.getSource("diq-gps-src")){
      map.addSource("diq-gps-src", { type:"geojson", data:emptyFC() });
      map.addLayer({
        id:"diq-gps-halo",
        type:"circle",
        source:"diq-gps-src",
        paint:{
          "circle-radius":["interpolate",["linear"],["zoom"],7,12,13,22,17,34],
          "circle-color":p.gps,
          "circle-opacity":0.24,
          "circle-blur":1
        }
      });
      map.addLayer({
        id:"diq-gps-dot",
        type:"circle",
        source:"diq-gps-src",
        paint:{
          "circle-radius":["interpolate",["linear"],["zoom"],7,5,13,8,17,12],
          "circle-color":p.gps,
          "circle-stroke-color":"#061018",
          "circle-stroke-width":4,
          "circle-opacity":0.98
        }
      });
      map.addLayer({
        id:"diq-gps-ring",
        type:"circle",
        source:"diq-gps-src",
        paint:{
          "circle-radius":["interpolate",["linear"],["zoom"],7,9,13,14,17,19],
          "circle-color":"rgba(0,0,0,0)",
          "circle-stroke-color":p.gpsRing,
          "circle-stroke-width":2,
          "circle-opacity":0.78
        }
      });
    }
  }catch(e){}
}

function setGpsPin(lng, lat){
  if(!mapLoaded || !map) return;
  ensureGpsSource();
  try{
    if(map.getSource("diq-gps-src")) map.getSource("diq-gps-src").setData(pointFC(lng, lat, { label:"YOU" }));
    if(map.getLayer("diq-gps-halo")) map.moveLayer("diq-gps-halo");
    if(map.getLayer("diq-gps-dot")) map.moveLayer("diq-gps-dot");
    if(map.getLayer("diq-gps-ring")) map.moveLayer("diq-gps-ring");
  }catch(e){}
}

function clearDestPin(){
  removeLayer("diq-dest-label");
  removeLayer("diq-dest-core");
  removeLayer("diq-dest-halo");
  removeSource("diq-dest-src");
}

function drawDestPin(){
  var p = startPalette();
  if(!mapLoaded || !map || !dest) return;
  clearDestPin();
  try{
    map.addSource("diq-dest-src", { type:"geojson", data:pointFC(dest.lng, dest.lat, { label:"DEST" }) });
    map.addLayer({
      id:"diq-dest-halo",
      type:"circle",
      source:"diq-dest-src",
      paint:{
        "circle-radius":["interpolate",["linear"],["zoom"],7,14,13,24,17,36],
        "circle-color":p.dest,
        "circle-opacity":0.28,
        "circle-blur":1
      }
    });
    map.addLayer({
      id:"diq-dest-core",
      type:"circle",
      source:"diq-dest-src",
      paint:{
        "circle-radius":["interpolate",["linear"],["zoom"],7,6,13,10,17,14],
        "circle-color":p.dest,
        "circle-stroke-color":"#061018",
        "circle-stroke-width":3,
        "circle-opacity":0.98
      }
    });
    map.addLayer({
      id:"diq-dest-label",
      type:"symbol",
      source:"diq-dest-src",
      layout:{
        "text-field":["get","label"],
        "text-size":10,
        "text-offset":[0,1.8],
        "text-font":["Open Sans Bold","Arial Unicode MS Bold"]
      },
      paint:{
        "text-color":p.accent3,
        "text-halo-color":"#061018",
        "text-halo-width":1.6
      }
    });
  }catch(e){}
}

/* =====================================================================
   V25 MULTI-ROUTE MAP PREVIEW
   Google-style pre-drive comparison:
   - selected route stays bright and authoritative
   - all other genuine routes stay visible underneath
   - each route gets a tappable ETA badge
   - tapping an alternate line or ETA badge selects that real route
   - Drive Mode handoff is unchanged: only routeGeo is persisted/started
===================================================================== */
function clearRouteEtaMarkers(){
  var i;
  for(i=0;i<routeEtaMarkers.length;i++){
    try{ routeEtaMarkers[i].remove(); }catch(e){}
  }
  routeEtaMarkers = [];
}

function clearRouteOptionPreview(){
  clearRouteEtaMarkers();
  removeLayer("diq-route-options-lines");
  removeLayer("diq-route-options-casing");
  removeSource("diq-route-options-src");
}

function routeFeatureCoordinates(feature){
  var out = [];
  if(!feature || !feature.geometry || !feature.geometry.coordinates) return out;
  collectRouteLngLats(feature.geometry.coordinates,out);
  return out;
}

function routeBadgeCoordinate(feature,index){
  var coords = routeFeatureCoordinates(feature);
  var fraction, idx;

  if(!coords.length) return null;

  /*
    V25.1: selected route badge previously landed near the upper-middle of
    long routes, where the Start Drive controls could cover it. Put the
    selected ETA farther down-route in the visible map, and stagger the
    alternates so all badges are easier to distinguish.
  */
  if(index === selectedRouteIndex){
    fraction = 0.34;
  }else{
    fraction = [0.58,0.66,0.74,0.50][index % 4];
  }

  idx = Math.max(0,Math.min(coords.length-1,Math.round((coords.length-1)*fraction)));
  return coords[idx] || null;
}

function bindRouteOptionMapClicks(){
  if(routeOptionMapClickBound || !map) return;

  try{
    map.on("click","diq-route-options-lines",function(e){
      var f = e && e.features && e.features.length ? e.features[0] : null;
      var idx = f && f.properties ? Number(f.properties.routeIndex) : null;

      if(idx !== null && finite(idx)){
        selectRouteOption(idx,true);
      }
    });

    map.on("mouseenter","diq-route-options-lines",function(){
      try{ map.getCanvas().style.cursor = "pointer"; }catch(e){}
    });

    map.on("mouseleave","diq-route-options-lines",function(){
      try{ map.getCanvas().style.cursor = ""; }catch(e){}
    });

    routeOptionMapClickBound = true;
  }catch(e){}
}

function makeRouteEtaBadge(opt,index){
  var el, isSelected, label;

  if(!opt || !window.mapboxgl || typeof mapboxgl.Marker !== "function") return null;

  isSelected = index === selectedRouteIndex;
  label = opt.intel && opt.intel.durationLabel
    ? String(opt.intel.durationLabel)
    : fmtTime(routeSeconds(opt));

  try{
    el = document.createElement("button");
    el.type = "button";
    el.setAttribute("aria-label","Select " + routeOptionLabel(opt.kind) + " route, " + label);
    el.setAttribute("data-route-index",String(index));
    el.style.cssText = [
      "appearance:none",
      "-webkit-appearance:none",
      "border:" + (isSelected ? "1px solid " + startPalette().accent3 : "1px solid rgba(255,255,255,.32)"),
      "background:" + (isSelected ? "linear-gradient(135deg," + startPalette().accent2 + "," + startPalette().accent + ")" : "rgba(7,17,28,.94)"),
      "color:" + (isSelected ? ((activeSkin === "carbon_rs" || activeSkin === "american_muscle") ? "#FFFFFF" : "#1E2228") : "#ffffff"),
      "min-height:32px",
      "padding:6px 9px",
      "border-radius:11px",
      "font:950 11px/1.05 system-ui,-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif",
      "letter-spacing:.1px",
      "white-space:nowrap",
      "box-shadow:" + (isSelected ? "0 8px 24px " + startPalette().glow : "0 8px 22px rgba(0,0,0,.42)"),
      "backdrop-filter:blur(12px)",
      "-webkit-backdrop-filter:blur(12px)",
      "cursor:pointer",
      "pointer-events:auto"
    ].join(";");

    el.textContent = label;

    el.onclick = function(e){
      if(e && e.preventDefault) e.preventDefault();
      if(e && e.stopPropagation) e.stopPropagation();
      selectRouteOption(index,true);
      return false;
    };

    return el;
  }catch(e2){
    return null;
  }
}

function drawRouteOptionPreview(){
  var features = [], i, opt, f, coords, badgeEl, markerObj, p = startPalette();

  if(!mapLoaded || !map) return;
  clearRouteOptionPreview();

  if(!routeOptions || routeOptions.length < 2) return;

  /* Only the NON-selected choices are drawn in the dim alternate layer.
     The selected choice is still drawn by drawRoute() with the normal bright
     Drive IQ route treatment. */
  for(i=0;i<routeOptions.length;i++){
    if(i === selectedRouteIndex) continue;
    opt = routeOptions[i];
    if(!opt || !opt.feature || !opt.feature.geometry) continue;

    f = {
      type:"Feature",
      properties:{
        routeIndex:i,
        kind:opt.kind || "alternate",
        durationSeconds:routeSeconds(opt)
      },
      geometry:opt.feature.geometry
    };
    features.push(f);
  }

  try{
    map.addSource("diq-route-options-src",{
      type:"geojson",
      data:{type:"FeatureCollection",features:features}
    });

    map.addLayer({
      id:"diq-route-options-casing",
      type:"line",
      source:"diq-route-options-src",
      layout:{"line-cap":"round","line-join":"round"},
      paint:{
        "line-color":"rgba(3,8,16,.78)",
        "line-width":["interpolate",["linear"],["zoom"],7,6,13,8,17,10],
        "line-opacity":0.72
      }
    });

    map.addLayer({
      id:"diq-route-options-lines",
      type:"line",
      source:"diq-route-options-src",
      layout:{"line-cap":"round","line-join":"round"},
      paint:{
        "line-color":p.accent3 || "#a8bdd2",
        "line-width":["interpolate",["linear"],["zoom"],7,3,13,4.5,17,6],
        "line-opacity":0.56
      }
    });

    bindRouteOptionMapClicks();
  }catch(e){}

  /* ETA badges are created for EVERY route, including the selected one. */
  for(i=0;i<routeOptions.length;i++){
    opt = routeOptions[i];
    coords = routeBadgeCoordinate(opt && opt.feature,i);
    if(!coords) continue;

    badgeEl = makeRouteEtaBadge(opt,i);
    if(!badgeEl) continue;

    try{
      markerObj = new mapboxgl.Marker({element:badgeEl,anchor:"center"})
        .setLngLat([Number(coords[0]),Number(coords[1])])
        .addTo(map);
      routeEtaMarkers.push(markerObj);
    }catch(markerErr){}
  }
}

function clearRouteLine(){
  clearRouteOptionPreview();
  removeLayer("diq-route-line");
  removeLayer("diq-route-glow");
  removeSource("diq-route-src");
}

function drawRoute(fc){
  var p = startPalette();
  if(!mapLoaded || !map || !fc || !fc.features || !fc.features.length) return;
  clearRouteLine();

  /* V25: paint the dim alternatives first so the selected route can sit above
     them in the normal bright Drive IQ route layer. */
  drawRouteOptionPreview();

  try{
    map.addSource("diq-route-src", { type:"geojson", data:fc, lineMetrics:true });
    map.addLayer({
      id:"diq-route-glow",
      type:"line",
      source:"diq-route-src",
      layout:{ "line-cap":"round", "line-join":"round" },
      paint:{ "line-color":p.routeGlow || p.accent, "line-width":18, "line-opacity":0.22 }
    });
    map.addLayer({
      id:"diq-route-line",
      type:"line",
      source:"diq-route-src",
      layout:{ "line-cap":"round", "line-join":"round" },
      paint:{
        "line-gradient":["interpolate",["linear"],["line-progress"],0,p.routeA,0.55,p.routeB,1,p.routeC],
        "line-width":["interpolate",["linear"],["zoom"],7,4,13,6,17,8],
        "line-opacity":0.96
      }
    });
  }catch(e){}

  /* Rebuild preview once more after the bright layer exists. This refreshes
     selected/non-selected ETA badge styling while keeping active route on top. */
  try{
    if(map.getLayer("diq-route-line")) map.moveLayer("diq-route-line");
    if(map.getLayer("diq-route-glow")) map.moveLayer("diq-route-glow","diq-route-line");
  }catch(e2){}

  /* drawRouteOptionPreview() clears only alternate preview assets, not the
     selected route. Re-create badges without disturbing the active source. */
  try{
    clearRouteEtaMarkers();
    var _i, _opt, _coord, _badge, _marker;
    for(_i=0;_i<routeOptions.length;_i++){
      _opt = routeOptions[_i];
      _coord = routeBadgeCoordinate(_opt && _opt.feature,_i);
      if(!_coord) continue;
      _badge = makeRouteEtaBadge(_opt,_i);
      if(!_badge) continue;
      _marker = new mapboxgl.Marker({element:_badge,anchor:"center"})
        .setLngLat([Number(_coord[0]),Number(_coord[1])])
        .addTo(map);
      routeEtaMarkers.push(_marker);
    }
  }catch(e3){}

  drawDestPin();
  scheduleRouteOverviewFit();
}

function flyTo(lng, lat, zoom){
  if(!mapLoaded || !map) return;
  try{ map.easeTo({ center:[Number(lng),Number(lat)], zoom:Number(zoom || 14.5), duration:650, essential:true }); }catch(e){}
}

function collectRouteLngLats(value, out){
  var i, a, b;
  if(!value || !out) return;
  if(Object.prototype.toString.call(value) === "[object Array]" &&
     value.length >= 2 &&
     finite(Number(value[0])) &&
     finite(Number(value[1]))){
    a = Number(value[0]);
    b = Number(value[1]);
    if(a >= -180 && a <= 180 && b >= -90 && b <= 90){ out.push([a,b]); }
    return;
  }
  if(Object.prototype.toString.call(value) === "[object Array]"){
    for(i=0;i<value.length;i++){ collectRouteLngLats(value[i], out); }
  }
}

function routeCoordinatePairs(){
  var geometry, out = [];
  if(!routeGeo || !routeGeo.features || !routeGeo.features.length) return out;
  geometry = routeGeo.features[0] && routeGeo.features[0].geometry ? routeGeo.features[0].geometry : null;
  if(!geometry || !geometry.coordinates) return out;
  collectRouteLngLats(geometry.coordinates, out);
  return out;
}

function routeBounds(){
  var coords, bounds, i, j, optionCoords;
  if(!routeGeo || !routeGeo.features || !routeGeo.features.length || !window.mapboxgl) return null;
  try{
    coords = routeCoordinatePairs();
    if(!coords.length) return null;
    bounds = new mapboxgl.LngLatBounds(coords[0], coords[0]);
    for(i=1;i<coords.length;i++){ bounds.extend(coords[i]); }

    /* V25: keep all visible choices inside the pre-drive overview. */
    for(i=0;i<routeOptions.length;i++){
      optionCoords = routeFeatureCoordinates(routeOptions[i] && routeOptions[i].feature);
      for(j=0;j<optionCoords.length;j++){
        bounds.extend(optionCoords[j]);
      }
    }

    if(lastFix && finite(Number(lastFix.lng)) && finite(Number(lastFix.lat))) bounds.extend([Number(lastFix.lng),Number(lastFix.lat)]);
    if(dest && finite(Number(dest.lng)) && finite(Number(dest.lat))) bounds.extend([Number(dest.lng),Number(dest.lat)]);
    return bounds;
  }catch(e){ return null; }
}

function routeOverviewPadding(){
  var vh = window.innerHeight || 844;
  var vw = window.innerWidth || 390;
  return {
    top:Math.round(Math.max(230, Math.min(310, vh * 0.30))),
    right:Math.round(Math.max(28, Math.min(54, vw * 0.09))),
    bottom:Math.round(Math.max(210, Math.min(285, vh * 0.27))),
    left:Math.round(Math.max(28, Math.min(54, vw * 0.09)))
  };
}

function fitRoute(force){
  var bounds, generation;
  if(!mapLoaded || !map || !routeGeo || !window.mapboxgl) return false;
  bounds = routeBounds();
  if(!bounds) return false;
  generation = routeOverviewGeneration;
  try{
    map.resize();
    if(typeof map.stop === "function") map.stop();
    map.fitBounds(bounds, {
      padding:routeOverviewPadding(),
      maxZoom:13.6,
      duration:force === false ? 650 : 800,
      bearing:0,
      pitch:0,
      essential:true,
      linear:false
    });
    routeOverviewLastFitAt = Date.now();
    routeOverviewLockUntil = Date.now() + 4200;
    setSubline(ruralRoadRecovery ? ruralRoadNotice() : "Route visible - ready to start drive");
    setStatus(ruralRoadRecovery ? "Road route found" : "Route ready",ruralRoadRecovery ? "gold" : "green");
    return generation === routeOverviewGeneration;
  }catch(e){ return false; }
}

function scheduleRouteOverviewFit(){
  var generation = ++routeOverviewGeneration;
  routeOverviewLockUntil = Date.now() + 5200;
  function refit(){
    if(generation !== routeOverviewGeneration) return;
    if(!routeReady || !routeGeo) return;
    fitRoute(true);
  }
  refit();
  window.setTimeout(refit,90);
  window.setTimeout(refit,260);
  window.setTimeout(refit,650);
  window.setTimeout(refit,1250);
  window.setTimeout(function(){
    if(generation !== routeOverviewGeneration) return;
    if(!routeReady || !routeGeo) return;
    fitRoute(false);
    toast("Route ready");
  },2100);
}

function acceptFix(pos, center){
  var c = pos && pos.coords ? pos.coords : {};
  var lat = num(c.latitude);
  var lng = num(c.longitude);
  if(lat === null || lng === null) return false;
  lastFix = {
    lat:lat,
    lng:lng,
    acc:finite(Number(c.accuracy)) ? Number(c.accuracy) : 0,
    heading:finite(Number(c.heading)) ? Number(c.heading) : null,
    speed:finite(Number(c.speed)) ? Number(c.speed) : null,
    ts:Date.now()
  };
  lsSetJSON(LS.LAST_FIX, lastFix);
  setGps("GPS: LOCKED");
  setStatus("GPS locked","green");
  setGpsPin(lng, lat);
  if(center && !(routeReady && routeGeo && Date.now() < routeOverviewLockUntil)){ flyTo(lng, lat, 15.5); }
  return true;
}

function requestGPS(center){
  if(!navigator || !navigator.geolocation){
    setGps("GPS: unavailable");
    setStatus("GPS unavailable","red");
    return false;
  }
  setGps("GPS: locking...");
  try{
    navigator.geolocation.getCurrentPosition(
      function(pos){ acceptFix(pos, !!center); },
      function(){ if(!lastFix){ setGps("GPS blocked"); setStatus("Tap GPS / allow location","gold"); toast("Allow location to drop your GPS pin"); } },
      { enableHighAccuracy:true, timeout:18000, maximumAge:0 }
    );
    if(gpsWatchId === null){
      gpsWatchId = navigator.geolocation.watchPosition(
        function(pos){ acceptFix(pos, false); },
        function(){},
        { enableHighAccuracy:true, timeout:25000, maximumAge:5000 }
      );
    }
  }catch(e){ return false; }
  return true;
}

function restoreGPS(center){
  var saved = lsGetJSON(LS.LAST_FIX);
  if(saved && finite(Number(saved.lat)) && finite(Number(saved.lng))){
    lastFix = { lat:Number(saved.lat), lng:Number(saved.lng), acc:Number(saved.acc || 0), heading:null, speed:null, ts:Number(saved.ts || 0) };
    setGps("GPS: SAVED");
    setGpsPin(lastFix.lng,lastFix.lat);
    if(center) flyTo(lastFix.lng,lastFix.lat,15.3);
  }
  requestGPS(!!center);
}

function looksAddress(q){
  var s = clean(q).toLowerCase();
  return /^\d{2,}\s+[a-z0-9]/i.test(s) || (/\d/.test(s) && /\b(st|street|rd|road|ave|avenue|blvd|boulevard|dr|drive|ln|lane|ct|court|cir|circle|pkwy|parkway|hwy|highway|way|pl|place|trl|trail)\b/i.test(s));
}
function kindForResult(p, q){
  var text = String((p.name || "") + " " + (p.formatted || "") + " " + (p.result_type || "")).toLowerCase();
  if(looksAddress(q) || p.result_type === "building") return "address";
  if(p.result_type === "city" || p.result_type === "county" || p.result_type === "state" || p.result_type === "postcode") return "city";
  if(text.indexOf("airport") > -1) return "airport";
  if(text.indexOf("hotel") > -1) return "hotel";
  if(text.indexOf("restaurant") > -1 || text.indexOf("food") > -1 || text.indexOf("coffee") > -1) return "food";
  return "place";
}
function kindLabel(kind){
  if(kind === "address") return "ADDRESS";
  if(kind === "city") return "CITY / AREA";
  if(kind === "airport") return "AIRPORT";
  if(kind === "hotel") return "HOTEL";
  if(kind === "food") return "FOOD";
  return "DESTINATION";
}
function normalizeSearchText(v){
  return clean(v).toLowerCase().replace(/[^a-z0-9\s]/g," ").replace(/\s+/g," ").trim();
}
function compactSearchText(v){ return normalizeSearchText(v).replace(/\s/g,""); }

function queryHasExplicitFarLocality(q){
  var s = clean(q);
  var n = normalizeSearchText(q);

  if(/\b\d{5}(?:-\d{4})?\b/.test(s)) return true;

  if(/,\s*(al|ak|az|ar|ca|co|ct|de|fl|ga|hi|id|il|in|ia|ks|ky|la|me|md|ma|mi|mn|ms|mo|mt|ne|nv|nh|nj|nm|ny|nc|nd|oh|ok|or|pa|ri|sc|sd|tn|tx|ut|vt|va|wa|wv|wi|wy|dc)\b/i.test(s)){
    return true;
  }

  if(/\b(alabama|alaska|arizona|arkansas|california|colorado|connecticut|delaware|florida|georgia|hawaii|idaho|illinois|indiana|iowa|kansas|kentucky|louisiana|maine|maryland|massachusetts|michigan|minnesota|mississippi|missouri|montana|nebraska|nevada|new hampshire|new jersey|new mexico|new york|north carolina|north dakota|ohio|oklahoma|oregon|pennsylvania|rhode island|south carolina|south dakota|tennessee|texas|utah|vermont|virginia|washington|west virginia|wisconsin|wyoming)\b/.test(n)){
    return true;
  }

  return false;
}

function businessSearchVariants(q){
  var base = clean(q), out = [], seen = {};

  function add(v){
    var k = normalizeSearchText(v);
    if(!k || seen[k]) return;
    seen[k] = true;
    out.push(clean(v));
  }

  add(base);

  /* "El Vera Cruz", "El Veracruz", and partial "El Vera" must be able to
     reach the same real Places listing. Suggestions still require provider data. */
  if(/^[a-z]+\s+[a-z]{2,}$/i.test(base) && !looksGenericCategoryQuery(base)){
    add(base.replace(/\s+/g,""));
  }
  if(/^el[a-z]{4,}$/i.test(base)) add(base.replace(/^el/i,"El "));

  if(/\bgrill\b/i.test(base)) add(base.replace(/\bgrill\b/ig,"Grille"));
  if(/\bgrille\b/i.test(base)) add(base.replace(/\bgrille\b/ig,"Grill"));

  if(/\bcenter\b/i.test(base)) add(base.replace(/\bcenter\b/ig,"Centre"));
  if(/\bcentre\b/i.test(base)) add(base.replace(/\bcentre\b/ig,"Center"));

  return out.slice(0,4);
}

function looksGenericCategoryQuery(q){
  var n = normalizeSearchText(q);
  return /^(food|restaurants?|coffee|cafes?|gas|fuel|hotels?|motels?|pharmacy|pharmacies|hospitals?|grocery|groceries|airport|airports|schools?|attractions?|bars?|breakfast|lunch|dinner|pizza|burgers?|fast food)( near me)?$/.test(n);
}

function businessStemQueries(q){
  var base = clean(q), tokens = base.split(/\s+/), out = [], seen = {};

  function add(v){
    var k = normalizeSearchText(v);
    if(!k || k.length < 2 || seen[k]) return;
    seen[k] = true;
    out.push(clean(v));
  }

  if(looksGenericCategoryQuery(base)) return out;
  if(tokens.length < 2) return out;

  /*
    Pro Driver Business + City recovery:
    "Windy City Hernando"   -> "Windy City"
    "10th Inning Southaven" -> "10th Inning"
    "FedEx Ground Olive Branch" -> "FedEx Ground Olive" + "FedEx Ground"
    We only use these as a second pass when the full query did not produce
    a strong nearby business-name match.
  */
  add(tokens.slice(0,-1).join(" "));

  if(tokens.length >= 4){
    add(tokens.slice(0,-2).join(" "));
  }

  return out.slice(0,2);
}

function dedupeSearchQueries(items){
  var seen = {}, out = [], i, key;
  for(i=0;i<(items || []).length;i++){
    key = normalizeSearchText(items[i]);
    if(!key || seen[key]) continue;
    seen[key] = true;
    out.push(clean(items[i]));
  }
  return out;
}

function bestNameMatchForQueries(name, queries){
  var best = 0, i, score;
  for(i=0;i<(queries || []).length;i++){
    score = nameMatchScore(name,queries[i]);
    if(score > best) best = score;
  }
  return best;
}

function hasStrongNearbyBusinessMatch(items, queries){
  var i, item, d, match;
  for(i=0;i<(items || []).length;i++){
    item = items[i];
    if(!item) continue;
    d = finite(item.distMiles) ? item.distMiles : 99999;
    match = bestNameMatchForQueries(item.label,queries);
    if(d <= 75 && match >= 680) return true;
  }
  return false;
}

function localBusinessRadiusMiles(q){
  return queryHasExplicitFarLocality(q) ? 500 : 75;
}

function filterLocalBusinessItems(items,q){
  var limit = localBusinessRadiusMiles(q);
  var out = [], i, item, kind;

  for(i=0;i<(items || []).length;i++){
    item = items[i];
    if(!item) continue;

    kind = String(item.kind || "");

    /*
      CITY SEARCH FIX:
      The 75-mile rule is for nearby business discovery, not geographic
      destinations. Never throw away a city, address, airport, county/state
      area result just because it is farther than the local business radius.
    */
    if(kind === "city" || kind === "address" || kind === "airport"){
      out.push(item);
      continue;
    }

    /*
      V21 GLOBAL EXACT BUSINESS RECOVERY:
      Distance must never discard a strong business-name match. A driver can
      search for a hotel, resort, restaurant, venue, etc. hundreds of miles away.
      Example: "Club Destin" from Memphis.
    */
    if(lastFix && finite(item.distMiles) && item.distMiles > limit){
      if(nameMatchScore(item.label,q) < 680){
        continue;
      }
    }

    out.push(item);
  }

  return out;
}

function editDistance(a,b){
  var s = normalizeSearchText(a), t = normalizeSearchText(b), i, j, prev = [], cur = [];
  if(!s) return t.length;
  if(!t) return s.length;
  for(j=0;j<=t.length;j++) prev[j]=j;
  for(i=1;i<=s.length;i++){
    cur[0]=i;
    for(j=1;j<=t.length;j++){
      cur[j]=Math.min(cur[j-1]+1,prev[j]+1,prev[j-1]+(s.charAt(i-1)===t.charAt(j-1)?0:1));
    }
    prev=cur.slice(0);
  }
  return prev[t.length];
}

function nameMatchScore(name,q){
  var n = normalizeSearchText(name), query = normalizeSearchText(q), maxLen, ratio, qTokens, nTokens, hits = 0, i;
  if(!n || !query) return 0;
  if(n === query) return 1200;
  if(n.indexOf(query) >= 0 || query.indexOf(n) >= 0) return 950;
  /* Ignore whitespace differences and match the leading part of a business
     name. This promotes real "El Veracruz" results for "El Vera" queries. */
  var nc=compactSearchText(name),qc=compactSearchText(q);
  if(qc.length>=4 && (nc.indexOf(qc)>=0 || qc.indexOf(nc)>=0)) return 940;
  maxLen = Math.max(n.length,query.length);
  ratio = maxLen ? 1 - (editDistance(n,query) / maxLen) : 0;
  qTokens = query.split(" ");
  nTokens = n.split(" ");
  for(i=0;i<qTokens.length;i++){ if(qTokens[i] && nTokens.indexOf(qTokens[i]) >= 0) hits += 1; }
  if(ratio >= 0.90) return 900;
  if(ratio >= 0.82) return 760;
  if(qTokens.length >= 2 && hits / qTokens.length >= 0.66) return 680;
  if(qTokens.length && hits / qTokens.length >= 0.50) return 420;
  return Math.round(Math.max(0,ratio) * 300);
}

function resultScore(item, q){
  var score = 0;
  var txt = String((item.label || "") + " " + (item.full || "")).toLowerCase();
  var query = clean(q).toLowerCase();
  if(item && item.provider === "google-places") score += 1400;
  if(query && txt.indexOf(query) > -1) score += 160;
  score += nameMatchScore(item && item.label, q);
  if(looksAddress(q) && item.kind === "address") score += 240;
  if(item.kind === "place") score += 70;
  if(item.kind === "city") score += 35;
  if(item && item.businessStatus === "OPERATIONAL") score += 90;
  if(item && item.businessStatus === "CLOSED_TEMPORARILY") score -= 350;
  if(finite(item.distMiles)){
    if(item.distMiles < 3) score += 80;
    else if(item.distMiles < 15) score += 45;
    else if(item.distMiles < 50) score += 20;
    else score -= Math.min(60, Math.round(item.distMiles / 10));
  }
  return score;
}
function dedupe(items){
  var seen = {}, out = [], i, item, key;
  for(i=0;i<items.length;i++){
    item = items[i];
    if(!item) continue;
    key = String(Number(item.lat).toFixed(5)) + "," + String(Number(item.lng).toFixed(5)) + "|" + String(item.label || "").toLowerCase();
    if(seen[key]) continue;
    seen[key] = true;
    out.push(item);
  }
  return out;
}
function normalizeGeoFeature(feature, q){
  var p = feature && feature.properties ? feature.properties : null;
  var lat, lng, label, full, item;
  if(!p) return null;
  lat = num(p.lat);
  lng = num(p.lon);
  if(lat === null || lng === null) return null;
  label = clean(p.name || p.address_line1 || p.formatted || q || "Destination");
  full = clean(p.formatted || p.address_line2 || "");
  item = { label:label, full:full, lat:lat, lng:lng, kind:kindForResult(p,q), distMiles:null };
  if(lastFix) item.distMiles = miles(lastFix.lat,lastFix.lng,lat,lng);
  return item;
}

function clearResults(){
  var box = byId("diqResults");
  if(!box) return;
  box.style.display = "none";
  box.innerHTML = "";
  box.__items = [];
}
function searchStillCurrent(query, runId){
  var input = byId("diqDestInput");
  if(runId !== lastSearchRun) return false;
  if(!input) return true;
  return normalizeSearchText(input.value) === normalizeSearchText(query);
}
function showResults(items){
  var box = byId("diqResults"), html = "", i, item, dist;
  if(!box) return;
  if(!items || !items.length){
    box.style.display = "block";
    box.innerHTML = '<div class="diqResultItem"><div class="diqResultMain"><span class="diqResultTitle">No strong matches yet</span></div><div class="diqResultSub">Try a full address, business, city, store, restaurant, hotel, airport, school, or attraction.</div></div>';
    return;
  }
  for(i=0;i<items.length;i++){
    item = items[i];
    dist = finite(item.distMiles) ? fmtMiles(item.distMiles) + " from you" : "Route-ready destination";
    if(item.businessStatus === "CLOSED_TEMPORARILY") dist = "Temporarily closed - " + dist;
    if(item.sourceLabel) dist += " - " + item.sourceLabel;
    html += '<button class="diqResultItem btn" type="button" data-index="' + String(i) + '">' +
      '<div class="diqResultMain"><span class="diqResultTitle">' + esc(item.label) + '</span></div>' +
      '<div class="diqResultBadge">' + esc(kindLabel(item.kind)) + '</div>' +
      '<div class="diqResultSub">' + esc(dist + (item.full ? " - " + item.full : "")) + '</div>' +
      '</button>';
  }
  box.__items = items;
  box.innerHTML = html;
  box.style.display = "block";
  bindResultClicks();
}
function bindResultClicks(){
  var box = byId("diqResults"), nodes, i;
  if(!box) return;
  nodes = box.querySelectorAll(".diqResultItem[data-index]");
  for(i=0;i<nodes.length;i++){
    nodes[i].onclick = function(){
      var item = box.__items && box.__items[Number(this.getAttribute("data-index"))];
      if(item) chooseDestination(item);
    };
  }
}
function geoUrl(q, mode){
  var key = getGeoapifyKey();
  var url = "https://api.geoapify.com/v1/geocode/" + mode + "?text=" + encodeURIComponent(q) + "&limit=8&format=geojson&apiKey=" + encodeURIComponent(key);
  if(lastFix) url += "&bias=proximity:" + encodeURIComponent(String(lastFix.lng)) + "," + encodeURIComponent(String(lastFix.lat));
  return url;
}
function geoapifyGeocode(q){
  var query = clean(q), runId, urls, done = 0, all = [];
  if(query.length < 2){ clearResults(); return Promise.resolve([]); }
  if(!getGeoapifyKey()) return Promise.resolve([]);
  runId = lastSearchRun;
  urls = [geoUrl(query,"autocomplete"), geoUrl(query,"search")];

  return new Promise(function(resolve){
    function finish(){
      var scored;
      done += 1;
      if(done < urls.length) return;
      if(runId !== lastSearchRun){ resolve([]); return; }
      scored = dedupe(all).sort(function(a,b){ return resultScore(b,query) - resultScore(a,query); }).slice(0,8);
      resolve(scored);
    }
    function readUrl(url){
      try{
        fetch(url).then(function(res){ return res.json(); }).then(function(data){
          var features = data && data.features ? data.features : [];
          var i, item;
          for(i=0;i<features.length;i++){
            item = normalizeGeoFeature(features[i], query);
            if(item){ item.provider = "geoapify"; item.sourceLabel = ""; all.push(item); }
          }
          finish();
        }).catch(function(){ finish(); });
      }catch(e){ finish(); }
    }
    readUrl(urls[0]);
    readUrl(urls[1]);
  });
}

function googlePlaceLatLng(place){
  var loc = place && place.location ? place.location : null;
  var lat = null, lng = null;
  if(!loc) return null;
  try{ lat = typeof loc.lat === "function" ? Number(loc.lat()) : Number(loc.lat); }catch(e1){}
  try{ lng = typeof loc.lng === "function" ? Number(loc.lng()) : Number(loc.lng); }catch(e2){}
  if(!finite(lat) || !finite(lng)) return null;
  return {lat:lat,lng:lng};
}

function googlePlaceKind(place,q){
  var types = place && place.types && place.types.length ? place.types.join(" ").toLowerCase() : "";
  var name = String(place && place.displayName || "").toLowerCase();

  if(looksAddress(q) || /street_address|premise|subpremise/.test(types)) return "address";

  /*
    Google can return geographic entities through Text Search. Treat all of
    the normal locality/admin variants as CITY / AREA so they are not handled
    like nearby businesses and accidentally radius-filtered away.
  */
  if(/(^|\s)(locality|postal_town|administrative_area_level_1|administrative_area_level_2|administrative_area_level_3|sublocality|sublocality_level_1|neighborhood|country)(\s|$)/.test(types)){
    return "city";
  }

  if(/airport/.test(types + " " + name)) return "airport";
  if(/lodging|hotel/.test(types + " " + name)) return "hotel";
  if(/restaurant|food|cafe|coffee|bakery|meal/.test(types + " " + name)) return "food";
  return "place";
}

function normalizeGooglePlace(place,q,index){
  var pos = googlePlaceLatLng(place);
  var status = String(place && place.businessStatus || "");
  var label, full, item;
  if(!pos) return null;
  if(status === "CLOSED_PERMANENTLY") return null;
  label = clean(place && place.displayName || q || "Destination");
  full = clean(place && place.formattedAddress || "");
  item = {
    label:label,
    full:full,
    lat:pos.lat,
    lng:pos.lng,
    kind:googlePlaceKind(place,q),
    distMiles:lastFix ? miles(lastFix.lat,lastFix.lng,pos.lat,pos.lng) : null,
    provider:"google-places",
    sourceLabel:"Google Maps",
    placeId:clean(place && place.id || ""),
    businessStatus:status,
    _googleOrder:Number(index || 0)
  };
  item._score = resultScore(item,q) - Number(index || 0) * 8;
  return item;
}

function searchGooglePlaces(q){
  var query = clean(q);
  var primaryVariants = businessSearchVariants(query);

  return ensureGooglePlaces().then(function(lib){
    /*
      New Places can fail to import while legacy PlacesService is still usable.
      Do not abandon Google business search before trying the legacy authority.
    */
    lib = lib || {};

    function normalizeLegacyPlace(raw){
      if(!raw) return null;

      return {
        id:clean(raw.place_id || ""),
        displayName:clean(raw.name || ""),
        formattedAddress:clean(raw.formatted_address || raw.vicinity || ""),
        location:raw.geometry && raw.geometry.location ? raw.geometry.location : null,
        businessStatus:clean(raw.business_status || ""),
        types:raw.types || []
      };
    }

    function runLegacyTextSearch(variant,globalSearch){
      return new Promise(function(resolve){
        var service, request;

        try{
          if(!window.google ||
             !google.maps ||
             !google.maps.places ||
             typeof google.maps.places.PlacesService !== "function"){
            resolve({variant:variant,places:[],globalSearch:!!globalSearch});
            return;
          }

          service = new google.maps.places.PlacesService(
            map || document.createElement("div")
          );

          request = { query:variant };

          /*
            Nearby/category discovery should stay biased to the driver's location.
            Global recovery intentionally omits location/radius so an exact named
            destination can be found anywhere in the U.S.
          */
          if(lastFix && !globalSearch){
            request.location = new google.maps.LatLng(
              Number(lastFix.lat),
              Number(lastFix.lng)
            );
            request.radius = 50000;
          }

          service.textSearch(request,function(results,status){
            var out = [], i, normalized;
            var ok =
              status === google.maps.places.PlacesServiceStatus.OK ||
              status === "OK";

            if(ok && results && results.length){
              for(i=0;i<results.length && i<10;i++){
                normalized = normalizeLegacyPlace(results[i]);
                if(normalized) out.push(normalized);
              }
            }

            resolve({variant:variant,places:out,globalSearch:!!globalSearch});
          });

        }catch(e){
          resolve({variant:variant,places:[],globalSearch:!!globalSearch});
        }
      });
    }

    function runVariant(variant,globalSearch){
      var request = {
        textQuery:variant,
        fields:["id","displayName","formattedAddress","location","businessStatus","types"],
        region:"us",
        maxResultCount:10
      };

      if(lastFix && !globalSearch){
        request.locationBias = {
          center:{lat:Number(lastFix.lat),lng:Number(lastFix.lng)},
          radius:50000
        };
      }

      /*
        Primary: Places API (New).
        Recovery: legacy Maps JS PlacesService textSearch.
        V21: globalSearch removes proximity bias for exact-name recovery.
      */
      if(lib && lib.Place && typeof lib.Place.searchByText === "function"){
        return lib.Place.searchByText(request).then(function(response){
          var places = response && response.places ? response.places : [];

          if(places.length){
            return {variant:variant,places:places,globalSearch:!!globalSearch};
          }

          return runLegacyTextSearch(variant,globalSearch);
        }).catch(function(){
          return runLegacyTextSearch(variant,globalSearch);
        });
      }

      return runLegacyTextSearch(variant,globalSearch);
    }

    function runQueries(queries,globalSearch){
      var jobs = [], i;
      for(i=0;i<queries.length;i++) jobs.push(runVariant(queries[i],!!globalSearch));
      return Promise.all(jobs);
    }

    function normalizeResults(results, scoringQueries){
      var items = [], closedExact = false, i, j, place, status, item, match, bestMatch;

      for(i=0;i<results.length;i++){
        for(j=0;j<results[i].places.length;j++){
          place = results[i].places[j];
          status = String(place && place.businessStatus || "");
          bestMatch = bestNameMatchForQueries(place && place.displayName,scoringQueries);
          match = nameMatchScore(place && place.displayName,results[i].variant);
          if(match > bestMatch) bestMatch = match;

          if(status === "CLOSED_PERMANENTLY"){
            if(bestMatch >= 680) closedExact = true;
            continue;
          }

          item = normalizeGooglePlace(place,query,j);
          if(item){
            item._variant = results[i].variant;
            item._nameMatch = bestMatch;
            item._score =
              resultScore(item,query) +
              bestMatch -
              Number(j || 0) * 8;
            items.push(item);
          }
        }
      }

      items = dedupe(items);
      items = filterLocalBusinessItems(items,query);

      items.sort(function(a,b){
        var ad = finite(a.distMiles) ? a.distMiles : 99999;
        var bd = finite(b.distMiles) ? b.distMiles : 99999;
        var am = Number(a._nameMatch || 0);
        var bm = Number(b._nameMatch || 0);

        if((bm >= 680) !== (am >= 680)) return bm >= 680 ? 1 : -1;
        if(am >= 680 && bm >= 680 && ad !== bd) return ad - bd;
        if(Number(b._score || 0) !== Number(a._score || 0)) return Number(b._score || 0) - Number(a._score || 0);
        return ad - bd;
      });

      return {items:items,closedExact:closedExact};
    }

    function strongGlobalNamedMatches(items,queries){
      var out = [], i, item, match;

      for(i=0;i<(items || []).length;i++){
        item = items[i];
        if(!item) continue;

        match = bestNameMatchForQueries(item.label,queries);

        /*
          680 = strong token/name match in the existing scorer.
          Exact/contained matches score 950-1200, so "Club Destin" wins cleanly
          over nearby "Club 152", "Club la rumba", etc.
        */
        if(match >= 680){
          item._nameMatch = Math.max(Number(item._nameMatch || 0),match);
          item._score = Number(item._score || resultScore(item,query)) + 2200 + match;
          out.push(item);
        }
      }

      out = dedupe(out);
      out.sort(function(a,b){
        var am = Number(a._nameMatch || 0);
        var bm = Number(b._nameMatch || 0);
        if(bm !== am) return bm - am;

        if(Number(b._score || 0) !== Number(a._score || 0)){
          return Number(b._score || 0) - Number(a._score || 0);
        }

        var ad = finite(a.distMiles) ? a.distMiles : 99999;
        var bd = finite(b.distMiles) ? b.distMiles : 99999;
        return ad - bd;
      });

      return out;
    }

    return runQueries(primaryVariants,false).then(function(primaryRaw){
      var primary = normalizeResults(primaryRaw,primaryVariants);
      var stems, expanded = [], i, stemVariants, scoringQueries;

      if(hasStrongNearbyBusinessMatch(primary.items,primaryVariants) || looksGenericCategoryQuery(query)){
        return {
          available:true,
          items:primary.items.slice(0,8),
          closedExact:primary.closedExact,
          variants:primaryVariants
        };
      }

      /*
        V21 GLOBAL EXACT BUSINESS RECOVERY:
        Before stripping words from a query, run the user's exact business/place
        name once without proximity bias. This prevents "Club Destin" from being
        reduced to "Club" and filled with nearby Memphis clubs.
      */
      return runQueries(primaryVariants,true).then(function(globalRaw){
        var globalNormalized = normalizeResults(globalRaw,primaryVariants);
        var strongGlobal = strongGlobalNamedMatches(globalNormalized.items,primaryVariants);
        var combinedStrong;

        if(strongGlobal.length){
          combinedStrong = dedupe(strongGlobal.concat(primary.items));

          combinedStrong.sort(function(a,b){
            var am = bestNameMatchForQueries(a.label,primaryVariants);
            var bm = bestNameMatchForQueries(b.label,primaryVariants);

            if(bm !== am) return bm - am;

            var as = Number(a._score || resultScore(a,query));
            var bs = Number(b._score || resultScore(b,query));
            if(bs !== as) return bs - as;

            var ad = finite(a.distMiles) ? a.distMiles : 99999;
            var bd = finite(b.distMiles) ? b.distMiles : 99999;
            return ad - bd;
          });

          return {
            available:true,
            items:combinedStrong.slice(0,8),
            closedExact:primary.closedExact || globalNormalized.closedExact,
            variants:primaryVariants
          };
        }

        /*
          Only after exact global recovery fails do we attempt the older business
          stem recovery ("Windy City Hernando" -> "Windy City", etc.).
        */
        stems = businessStemQueries(query);
        if(!stems.length){
          return {
            available:true,
            items:primary.items.slice(0,8),
            closedExact:primary.closedExact || globalNormalized.closedExact,
            variants:primaryVariants
          };
        }

        for(i=0;i<stems.length;i++){
          stemVariants = businessSearchVariants(stems[i]);
          expanded = expanded.concat(stemVariants);
        }
        expanded = dedupeSearchQueries(expanded);

        return runQueries(expanded,false).then(function(recoveryRaw){
          var recovery;
          scoringQueries = primaryVariants.concat(expanded);
          recovery = normalizeResults(primaryRaw.concat(recoveryRaw),scoringQueries);

          /*
            If the second-pass business stem found strong nearby name matches,
            suppress unrelated locality/civic results such as City Hall.
          */
          if(hasStrongNearbyBusinessMatch(recovery.items,expanded)){
            recovery.items = recovery.items.filter(function(item){
              return Number(item._nameMatch || 0) >= 420;
            });
          }

          return {
            available:true,
            items:recovery.items.slice(0,8),
            closedExact:primary.closedExact || globalNormalized.closedExact || recovery.closedExact,
            variants:scoringQueries
          };
        });
      });
    });
  });
}

function mergeCityRecovery(googleItems, geoItems, q){
  var combined = (googleItems || []).slice(0);
  var query = clean(q);
  var shortQuery = !/\d/.test(query) && normalizeSearchText(query).split(" ").length <= 4;
  var i, item, cityScore;

  if(!shortQuery) return combined;

  for(i=0;i<(geoItems || []).length;i++){
    item = geoItems[i];
    if(!item || item.kind !== "city") continue;

    /*
      Only promote a geographic result when it substantially resembles the
      user's query. This lets "Memphis", "Memphis TN", "Southaven MS", etc.
      surface without polluting ordinary business-name searches.
    */
    cityScore = nameMatchScore(item.label,q);
    if(cityScore >= 680 || normalizeSearchText(item.full).indexOf(normalizeSearchText(q)) >= 0){
      item._score = resultScore(item,q) + 1650;
      combined.push(item);
    }
  }

  combined = dedupe(combined);
  combined.sort(function(a,b){
    var as = finite(Number(a._score)) ? Number(a._score) : resultScore(a,q);
    var bs = finite(Number(b._score)) ? Number(b._score) : resultScore(b,q);
    if(bs !== as) return bs - as;

    var ad = finite(a.distMiles) ? a.distMiles : 99999;
    var bd = finite(b.distMiles) ? b.distMiles : 99999;
    return ad - bd;
  });

  return combined.slice(0,8);
}

function geocode(q){
  var query = clean(q), runId;
  if(query.length < 2){ clearResults(); return; }
  runId = Date.now();
  lastSearchRun = runId;
  setStatus("Searching Google Places","blue");

  /* Keep address behavior stable; Pro Driver business/POI search is Google-first. */
  if(looksAddress(query)){
    geoapifyGeocode(query).then(function(items){
      if(runId !== lastSearchRun) return;
      showResults(items);
      setStatus(items.length ? "Results ready" : "No match yet",items.length ? "green" : "gold");
    });
    return;
  }

  searchGooglePlaces(query).then(function(googleResult){
    if(runId !== lastSearchRun) return;

    if(googleResult && googleResult.items && googleResult.items.length){
      /*
        CITY SEARCH FIX:
        Google remains the authority for businesses/POIs, but Geoapify is also
        asked for geographic entities. Only strong city/area matches are merged.
        This guarantees city destinations can surface even when Places Text
        Search returns businesses but omits the locality itself.
      */
      if(getGeoapifyKey()){
        geoapifyGeocode(query).then(function(geoItems){
          var merged;
          if(runId !== lastSearchRun) return;
          merged = mergeCityRecovery(googleResult.items,geoItems,query);
          showResults(merged);
          setStatus("Search results ready","green");
        });
      }else{
        showResults(googleResult.items);
        setStatus("Google Places results","green");
      }
      return;
    }

    /* If Google identifies the requested business as permanently closed,
       do not resurrect a stale Geoapify copy of the same business. */
    if(googleResult && googleResult.closedExact){
      showResults([]);
      setStatus("No active Google place found","gold");
      toast("That place appears permanently closed");
      return;
    }

    setStatus("Checking fallback search","blue");
    geoapifyGeocode(query).then(function(items){
      if(runId !== lastSearchRun) return;
      items = filterLocalBusinessItems(items,query);
      showResults(items);
      setStatus(items.length ? "Fallback results" : "No match yet",items.length ? "green" : "gold");
    });
  });
}

function chooseDestination(item){
  routeOverviewGeneration += 1;
  routeOverviewLockUntil = 0;

  /* V13 SEARCH COMMIT AUTHORITY:
     Once the driver chooses a destination, kill every pending/debounced search
     so an older Google/Geoapify response can never reopen the results panel. */
  if(searchTimer){
    window.clearTimeout(searchTimer);
    searchTimer = null;
  }
  lastSearchRun = Date.now();

  dest = { label:item.label, full:item.full, lat:Number(item.lat), lng:Number(item.lng), kind:item.kind || "destination", provider:item.provider || "", placeId:item.placeId || "" };
  routeGeo = null;
  routeReady = false;
  lsSetJSON(LS.DEST,dest);
  lsRemove(LS.ROUTE_GEO);
  lsRemove(LS.ROUTE_INTEL);
  lsRemove(LS.ROUTE_OPTIONS);
  lsRemove(LS.SELECTED_ROUTE_KIND);
  routeOptions = [];
  selectedRouteIndex = 0;
  routeOptionsCollapsed = false;
  hideRouteOptions();
  if(byId("diqDestInput")){
    byId("diqDestInput").value = dest.label;
    try{ byId("diqDestInput").blur(); }catch(e0){}
  }
  clearResults();
  clearRouteLine();
  drawDestPin();
  updateRoutePanel(null);
  setSubline("Destination selected - tap Route Now");
  setStatus("Destination set","green");
  toast("Destination selected");
  flyTo(dest.lng,dest.lat,15);
}

function buildWaypoints(){
  if(!lastFix || !dest) return "";
  return String(lastFix.lat) + "," + String(lastFix.lng) + "|" + String(dest.lat) + "," + String(dest.lng);
}
function routeFeatureFromData(data, sourceKind){
  var features = data && data.features ? data.features : [];
  var feature, props, distanceMeters, durationSeconds;

  if(!features.length) return null;

  feature = features[0];
  props = feature.properties || {};
  distanceMeters = Number(props.distance || props.distanceMeters || 0);
  durationSeconds = Number(props.time || props.duration || props.durationSeconds || 0);

  if(!finite(distanceMeters) || distanceMeters <= 0) return null;
  if(!finite(durationSeconds) || durationSeconds <= 0) return null;

  feature.properties = feature.properties || {};
  feature.properties.distanceMeters = distanceMeters;
  feature.properties.durationSeconds = durationSeconds;
  feature.properties.driveIqRouteSource = sourceKind || "balanced";

  feature.properties.driveIqRoadProfile = roadProfileFromFeature(feature);

  return feature;
}

/* Highway IQ only trusts provider road class plus segment length. A road name,
   route shape, or a highway number by itself is not evidence of mileage share.
   If the provider omits usable class coverage, retain legacy ranking. */
function roadProfileFromFeature(feature){
  var p=feature&&feature.properties||{},total=Number(p.distanceMeters||p.distance||0);
  var segments=[],i,j,leg,details=p.route_details||p.routeDetails||[];
  if(Array.isArray(details)) segments=segments.concat(details);
  if(Array.isArray(p.legs)){
    for(i=0;i<p.legs.length;i++){
      leg=p.legs[i];
      if(leg&&Array.isArray(leg.steps)) segments=segments.concat(leg.steps);
    }
  }
  var known=0,highway=0,s,d,cls;
  for(j=0;j<segments.length;j++){
    s=segments[j];
    if(!s||typeof s!=="object") continue;
    cls=clean(s.road_class||s.roadClass||s.highway_class||s.highwayClass||"").toLowerCase();
    d=Number(s.distanceMeters!=null?s.distanceMeters:s.distance);
    if(!cls||!finite(d)||d<=0||d>total) continue;
    known+=d;
    if(/^(motorway|motorway_link|trunk|trunk_link)$/.test(cls)) highway+=d;
  }
  if(total<=0||known<total*0.65||known>total*1.15){
    return {verified:false,share:null,coverage:total>0?known/total:0};
  }
  return {verified:true,share:Math.min(1,highway/known),coverage:known/total};
}

function routeRoadProfile(opt){
  return opt&&opt.feature&&opt.feature.properties&&opt.feature.properties.driveIqRoadProfile||null;
}
function routeRoadDescription(opt){
  var p=routeRoadProfile(opt);
  if(!p||!p.verified) return "";
  if(p.share>=0.65) return "Mostly interstate / major highway";
  if(p.share<=0.20) return "Mostly non-interstate roads";
  return "Mixed highway and local roads";
}

function routeSampleSignature(feature){
  var g = feature && feature.geometry ? feature.geometry : null;
  var coords = g && g.coordinates ? g.coordinates : null;
  var flat = [], samples = [], i, idx, p;

  collectRouteLngLats(coords,flat);
  if(!flat.length) return "";

  for(i=0;i<7;i++){
    idx = Math.round((flat.length - 1) * (i / 6));
    p = flat[idx];
    samples.push(
      String(Math.round(Number(p[0]) * 50) / 50) + "," +
      String(Math.round(Number(p[1]) * 50) / 50)
    );
  }

  return samples.join("|");
}

function routesMeaningfullyDifferent(a,b){
  var sigA, sigB, pa, pb, same = 0, i;
  var propsA = a && a.properties ? a.properties : {};
  var propsB = b && b.properties ? b.properties : {};
  var distA = Number(propsA.distanceMeters || 0);
  var distB = Number(propsB.distanceMeters || 0);
  var timeA = Number(propsA.durationSeconds || 0);
  var timeB = Number(propsB.durationSeconds || 0);

  sigA = routeSampleSignature(a);
  sigB = routeSampleSignature(b);

  if(sigA && sigB){
    pa = sigA.split("|");
    pb = sigB.split("|");
    for(i=0;i<Math.min(pa.length,pb.length);i++){
      if(pa[i] === pb[i]) same += 1;
    }

    /* Same corridor at 6 of 7 sampled locations = not a useful choice. */
    if(same >= 6) return false;
  }

  /* Near-identical distance + ETA is almost always the same practical route. */
  if(distA > 0 && distB > 0 && timeA > 0 && timeB > 0){
    if(Math.abs(distA-distB) / Math.max(distA,distB) < 0.012 &&
       Math.abs(timeA-timeB) / Math.max(timeA,timeB) < 0.012){
      return false;
    }
  }

  return true;
}

function routeOptionLabel(kind){
  if(kind === "recommended") return "Recommended";
  if(kind === "fastest") return "Fastest";
  if(kind === "calmer") return "Calmer";
  return "Alternate";
}

function routeOptionName(kind){
  if(kind === "recommended") return "Best Overall";
  if(kind === "fastest") return "Quickest ETA";
  if(kind === "calmer") return "Low Stress";
  return "Different Way";
}

function routeSeconds(opt){
  return Number(
    opt &&
    opt.feature &&
    opt.feature.properties &&
    opt.feature.properties.durationSeconds || 0
  );
}

function shortestRouteSeconds(){
  var best = 0, i, sec;
  for(i=0;i<routeOptions.length;i++){
    sec = routeSeconds(routeOptions[i]);
    if(sec > 0 && (!best || sec < best)) best = sec;
  }
  return best;
}

function fmtDelta(seconds){
  var mins = Math.round(Number(seconds || 0) / 60);
  var h, r;
  if(!finite(mins) || mins <= 0) return "";
  h = Math.floor(mins / 60);
  r = mins % 60;
  if(h <= 0) return "+" + String(r) + " min";
  if(r <= 0) return "+" + String(h) + " hr";
  return "+" + String(h) + " hr " + String(r) + " min";
}

function routeOptionReason(kind,opt){
  var fastestSec = shortestRouteSeconds();
  var thisSec = routeSeconds(opt);
  var delta = fastestSec > 0 && thisSec > fastestSec
    ? fmtDelta(thisSec - fastestSec)
    : "";

  if(kind === "recommended"){
    var road=routeRoadDescription(opt);
    if(delta) return (road?road+" - ":"Balanced route - ") + delta + " vs fastest";
    return road ? road + " - best overall" : "Best overall and fastest available";
  }

  if(kind === "fastest"){
    return "Lowest ETA available";
  }

  if(kind === "calmer"){
    return delta
      ? "Fewer maneuvers - " + delta + " vs fastest"
      : "Fewer maneuver-heavy roads";
  }

  return delta
    ? "Different corridor - " + delta + " vs fastest"
    : "Another genuinely different corridor";
}

function routeOptionMeta(opt){
  var base = String(opt.intel.durationLabel) + " - " + String(opt.intel.miles) + " mi";
  var reason = routeOptionReason(opt.kind,opt);
  return reason ? base + " - " + reason : base;
}

function routeOptionDisplayKind(opt,index){
  var kind = opt && opt.kind ? String(opt.kind) : "alternate";

  if(kind !== "alternate") return kind;

  /* Multiple genuine alternates can exist. Give each one a distinct human
     label without pretending we know more than the routing response proves. */
  if(index === 1) return "alternate";
  if(index === 2) return "alternate2";
  if(index === 3) return "alternate3";
  return "alternate";
}

function routeOptionDisplayLabel(opt,index){
  var kind = routeOptionDisplayKind(opt,index);
  if(kind === "recommended") return "Recommended";
  if(kind === "fastest") return "Fastest";
  if(kind === "calmer") return "Calmer";
  if(kind === "alternate2") return "Alternate 2";
  if(kind === "alternate3") return "Alternate 3";
  return "Alternate";
}

function routeOptionDisplayName(opt,index){
  var kind = routeOptionDisplayKind(opt,index);
  if(kind === "recommended") return "Best Overall";
  if(kind === "fastest") return "Quickest ETA";
  if(kind === "calmer") return "Low Stress";
  if(kind === "alternate2") return "Another Way";
  if(kind === "alternate3") return "More Options";
  return "Different Way";
}

function routeOptionShortMeta(opt){
  if(!opt || !opt.intel) return "";
  return String(opt.intel.durationLabel || "") +
    (opt.intel.miles !== undefined && opt.intel.miles !== null
      ? " · " + String(opt.intel.miles) + " mi"
      : "");
}

function routeOptionShortReason(opt){
  var fastestSec = shortestRouteSeconds();
  var thisSec = routeSeconds(opt);
  var delta = fastestSec > 0 && thisSec > fastestSec
    ? fmtDelta(thisSec - fastestSec)
    : "";

  if(!opt) return "";
  if(opt.kind === "recommended"){
    var road=routeRoadDescription(opt);
    return (road?road+" · ":"")+(delta?delta+" vs fastest":"Best overall");
  }
  if(opt.kind === "fastest") return "Lowest ETA";
  if(opt.kind === "calmer") return delta ? "Calmer · " + delta : "Fewer maneuvers";
  return delta ? "Different corridor · " + delta : "Different corridor";
}

function makeRouteOptionCard(opt,index){
  var btn;

  try{
    btn = document.createElement("button");
    btn.className = "diqRouteOption" + (index === selectedRouteIndex ? " selected" : "");
    btn.type = "button";
    btn.id = "diqRouteOptionDynamic" + String(index);
    btn.setAttribute("data-route-index",String(index));
    btn.setAttribute("data-route-kind",String(opt && opt.kind || "alternate"));
    btn.setAttribute("aria-label",routeOptionDisplayLabel(opt,index) + " route option");

    btn.innerHTML =
      '<span class="diqRouteOptionBadge">' + esc(routeOptionDisplayLabel(opt,index)) + '</span>' +
      '<div class="diqRouteOptionName">' + esc(routeOptionDisplayName(opt,index)) + '</div>' +
      '<div class="diqRouteOptionMeta">' + esc(routeOptionShortMeta(opt)) + '</div>' +
      '<div class="diqRouteOptionReason">' + esc(routeOptionShortReason(opt)) + '</div>';

    btn.onclick = function(){
      selectRouteOption(index,true);
    };

    return btn;
  }catch(e){
    return null;
  }
}

function hideRouteOptions(){
  var wrap = byId("diqRouteOptions");
  var list = byId("diqRouteOptionsList");

  if(wrap) wrap.classList.remove("on");
  if(list){
    list.innerHTML = "";
    list.style.gridTemplateColumns = "";
  }
}

function ensureRouteChooserCleanupCss(){
  var style;
  if(byId("diqRouteChooserCleanupV251")) return;

  try{
    style = document.createElement("style");
    style.id = "diqRouteChooserCleanupV251";
    style.type = "text/css";
    style.textContent =
      '#diqRouteOptionsList .diqRouteOption{min-width:0!important;}'+
      '#diqRouteOptionsList .diqRouteOptionMeta{white-space:nowrap!important;overflow:hidden!important;text-overflow:ellipsis!important;}'+
      '#diqRouteOptionsList .diqRouteOptionReason{white-space:nowrap!important;overflow:hidden!important;text-overflow:ellipsis!important;}'+
      '#diqRouteOptions.diqRouteOptionsCollapsed{padding-bottom:7px!important;}'+
      '#diqRouteOptions.diqRouteOptionsCollapsed .diqRouteOptionsHead{margin-bottom:0!important;}'+
      '@media(max-width:430px){'+
        '#diqRouteOptionsList[style*="repeat(3"]{gap:5px!important;}'+
        '#diqRouteOptionsList[style*="repeat(3"] .diqRouteOption{padding:6px 5px!important;min-height:58px!important;}'+
        '#diqRouteOptionsList[style*="repeat(3"] .diqRouteOptionBadge{font-size:6px!important;padding:3px 4px!important;}'+
        '#diqRouteOptionsList[style*="repeat(3"] .diqRouteOptionName{font-size:10px!important;margin-top:4px!important;}'+
        '#diqRouteOptionsList[style*="repeat(3"] .diqRouteOptionMeta{font-size:7.5px!important;}'+
        '#diqRouteOptionsList[style*="repeat(3"] .diqRouteOptionReason{display:none!important;}'+
      '}';
    document.head.appendChild(style);
  }catch(e){}
}


function ensureRouteOptionsMinimizeControl(){
  var head = document.querySelector("#diqRouteOptions .diqRouteOptionsHead");
  var hint = byId("diqRouteOptionsHint");
  var btn = byId("diqRouteOptionsMinimize");

  if(!head) return null;
  if(btn) return btn;

  try{
    btn = document.createElement("button");
    btn.id = "diqRouteOptionsMinimize";
    btn.type = "button";
    btn.setAttribute("aria-label","Minimize route options");
    btn.setAttribute("aria-expanded","true");
    btn.textContent = "−";
    btn.style.cssText = [
      "width:28px",
      "height:28px",
      "min-width:28px",
      "border-radius:10px",
      "border:1px solid rgba(255,255,255,.18)",
      "background:rgba(255,255,255,.07)",
      "color:#fff",
      "font:1000 18px/1 system-ui,-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif",
      "display:grid",
      "place-items:center",
      "padding:0",
      "margin-left:8px",
      "box-shadow:inset 0 1px 0 rgba(255,255,255,.08)",
      "cursor:pointer",
      "pointer-events:auto"
    ].join(";");

    btn.onclick = function(e){
      if(e && e.preventDefault) e.preventDefault();
      if(e && e.stopPropagation) e.stopPropagation();
      routeOptionsCollapsed = !routeOptionsCollapsed;
      applyRouteOptionsCollapsedState();
      return false;
    };

    if(hint && hint.parentNode === head){
      head.appendChild(btn);
    }else{
      head.appendChild(btn);
    }
  }catch(e2){
    return null;
  }

  return btn;
}

function applyRouteOptionsCollapsedState(){
  var wrap = byId("diqRouteOptions");
  var list = byId("diqRouteOptionsList");
  var btn = byId("diqRouteOptionsMinimize");
  var hint = byId("diqRouteOptionsHint");

  if(!wrap || !list) return;

  if(routeOptionsCollapsed){
    list.style.display = "none";
    wrap.classList.add("diqRouteOptionsCollapsed");
    if(btn){
      btn.textContent = "+";
      btn.setAttribute("aria-label","Expand route options");
      btn.setAttribute("aria-expanded","false");
    }
    if(hint){
      hint.textContent = String(routeOptions.length) +
        (routeOptions.length === 1 ? " route" : " routes");
    }
  }else{
    list.style.display = "grid";
    wrap.classList.remove("diqRouteOptionsCollapsed");
    if(btn){
      btn.textContent = "−";
      btn.setAttribute("aria-label","Minimize route options");
      btn.setAttribute("aria-expanded","true");
    }
    if(hint){
      hint.textContent = routeOptions.length === 1
        ? "1 route available"
        : String(routeOptions.length) + " routes available";
    }
  }
}

function renderRouteOptions(){
  var wrap = byId("diqRouteOptions");
  var list = byId("diqRouteOptionsList");
  var hint = byId("diqRouteOptionsHint");
  var i, btn;

  if(!wrap || !list) return;

  ensureRouteChooserCleanupCss();
  ensureRouteOptionsMinimizeControl();

  /*
    V25.1: rebuild the chooser from routeOptions every time.
    The old implementation reused one button per KIND, so two routes both
    classified as "alternate" fought over the same DOM button. That is why
    the header could say "3 routes available" while only two cards appeared.
  */
  list.innerHTML = "";

  for(i=0;i<routeOptions.length && i<4;i++){
    btn = makeRouteOptionCard(routeOptions[i],i);
    if(btn) list.appendChild(btn);
  }

  if(routeOptions.length >= 4){
    list.style.gridTemplateColumns = "1fr 1fr";
  }else if(routeOptions.length === 3){
    list.style.gridTemplateColumns = "repeat(3,minmax(0,1fr))";
  }else if(routeOptions.length === 2){
    list.style.gridTemplateColumns = "1fr 1fr";
  }else{
    list.style.gridTemplateColumns = "1fr";
  }

  if(hint){
    hint.textContent = routeOptions.length === 1
      ? "1 route available"
      : String(routeOptions.length) + " routes available";
  }

  if(routeOptions.length > 1) wrap.classList.add("on");
  else wrap.classList.remove("on");

  applyRouteOptionsCollapsedState();
}

function selectRouteOption(index, announce){
  var opt;

  index = Number(index);
  if(!finite(index) || index < 0 || index >= routeOptions.length) return false;

  selectedRouteIndex = index;
  opt = routeOptions[index];

  routeGeo = routeFC(opt.feature);
  routeReady = true;
  routeGeo.features[0].properties.driveIqIntel = opt.intel;

  lsSetJSON(LS.ROUTE_GEO,routeGeo);
  lsSetJSON(LS.ROUTE_INTEL,opt.intel);
  lsSet(LS.SELECTED_ROUTE_KIND,opt.kind);

  renderRouteOptions();
  drawRoute(routeGeo);
  updateRoutePanel(opt.intel);

  setStatus(routeOptionDisplayLabel(opt,index) + " selected","green");
  setSubline(routeOptionDisplayLabel(opt,index) + " route - ready to start");

  if(announce !== false){
    toast(routeOptionDisplayLabel(opt,index) + " route selected");
  }

  return true;
}

function classifyRouteOptions(candidates){
  var unique = [], i, j, feature, duplicate;
  var balanced = null, fastest = null, calmer = null;
  var recommended = null, out = [];
  var fastestSec = 0, balancedSec = 0;
  var maxRecommendedPenaltySeconds = 35 * 60;
  var maxRecommendedPenaltyRatio = 0.12;

  for(i=0;i<candidates.length;i++){
    feature = candidates[i].feature;
    if(!feature) continue;

    duplicate = false;
    for(j=0;j<unique.length;j++){
      if(!routesMeaningfullyDifferent(feature,unique[j].feature)){
        duplicate = true;
        break;
      }
    }

    if(!duplicate) unique.push(candidates[i]);
  }

  if(!unique.length) return out;

  for(i=0;i<unique.length;i++){
    if(unique[i].sourceKind === "balanced_traffic" && !balanced){
      balanced = unique[i];
    }

    if(unique[i].sourceKind === "less_maneuvers" && !calmer){
      calmer = unique[i];
    }

    if(!fastest ||
       Number(unique[i].feature.properties.durationSeconds || 0) <
       Number(fastest.feature.properties.durationSeconds || 0)){
      fastest = unique[i];
    }
  }

  if(!balanced) balanced = unique[0];

  fastestSec = Number(fastest && fastest.feature && fastest.feature.properties.durationSeconds || 0);
  balancedSec = Number(balanced && balanced.feature && balanced.feature.properties.durationSeconds || 0);

  /*
    Recommendation sanity guard:
    "Balanced + traffic" is our preferred recommendation only while its ETA
    stays reasonably close to the actual fastest route.

    We do NOT have enough evidence in this routing response to justify calling
    a route "Recommended" when it is hours slower. If it exceeds either:
      - 35 minutes slower, AND
      - 12% slower than fastest
    then the fastest route becomes Recommended.

    This prevents cases like 11 hr Recommended vs 7 hr 39 min Fastest from
    looking irrational without inventing traffic/weather benefits we cannot prove.
  */
  recommended = balanced;

  /* Prefer a demonstrably highway-heavy candidate on trips >=30 minutes only
     when provider road-class coverage is sufficient AND ETA is close. The
     nighttime window is a modest preference, not a road-safety guarantee. */
  if(fastestSec >= 30*60){
    var hour=(new Date()).getHours(),night=hour>=19||hour<6;
    var allowance=Math.min(night?8*60:5*60,fastestSec*(night?0.12:0.10));
    var baseline=roadProfileFromFeature(balanced.feature),bestHighway=null;
    var bestShare=baseline.verified?baseline.share:-1,profile,sec;
    for(i=0;i<unique.length;i++){
      sec=Number(unique[i].feature.properties.durationSeconds||0);
      profile=roadProfileFromFeature(unique[i].feature);
      if(!profile.verified||sec<fastestSec||sec-fastestSec>allowance) continue;
      if(profile.share>=0.50&&profile.share>bestShare+0.20){
        bestHighway=unique[i];bestShare=profile.share;
      }
    }
    if(bestHighway) recommended=bestHighway;
  }

  if(fastest && recommended && fastest !== recommended && fastestSec > 0){
    var recommendedSec=Number(recommended.feature.properties.durationSeconds||0);
    if((recommendedSec-fastestSec)>maxRecommendedPenaltySeconds &&
       (recommendedSec-fastestSec)/fastestSec>maxRecommendedPenaltyRatio){
      recommended = fastest;
    }
  }

  function add(candidate,kind){
    var k;
    if(!candidate) return;
    for(k=0;k<out.length;k++){
      if(out[k].candidate === candidate) return;
    }

    out.push({
      candidate:candidate,
      feature:candidate.feature,
      intel:makeIntel(
        Number(candidate.feature.properties.distanceMeters || 0),
        Number(candidate.feature.properties.durationSeconds || 0)
      ),
      kind:kind
    });
  }

  add(recommended,"recommended");

  /* Only show a separate Fastest card when Fastest is not already Recommended. */
  if(fastest !== recommended){
    add(fastest,"fastest");
  }

  /* Calmer stays independent only when it is genuinely a different route. */
  if(calmer !== recommended && calmer !== fastest){
    add(calmer,"calmer");
  }

  /* Prefer the traffic-aware balanced route as an Alternate if the guardrail
     promoted Fastest to Recommended. */
  if(balanced !== recommended && balanced !== fastest && balanced !== calmer){
    add(balanced,"alternate");
  }

  /* Fill any remaining slots with genuinely distinct corridors. */
  for(i=0;i<unique.length && out.length<4;i++){
    if(unique[i] !== recommended &&
       unique[i] !== fastest &&
       unique[i] !== calmer &&
       unique[i] !== balanced){
      add(unique[i],"alternate");
    }
  }

  /* If we still have room and balanced was demoted but not yet added, keep it
     as a transparent Alternate instead of incorrectly calling it Recommended. */
  if(out.length < 4 && balanced !== recommended){
    add(balanced,"alternate");
  }

  return out.slice(0,4);
}

function routeUrlForVariant(wp,variant){
  var url = "https://api.geoapify.com/v1/routing?waypoints=" +
    encodeURIComponent(wp) +
    "&mode=drive" +
    "&type=" + encodeURIComponent(variant.type) +
    "&traffic=" + encodeURIComponent(variant.traffic) +
    "&details=instruction_details,route_details" +
    "&format=geojson" +
    "&apiKey=" + encodeURIComponent(getGeoapifyKey());

  return url;
}

/* V25.8 RURAL ROAD RECOVERY. Geoapify map matching is used only after an
   actual no-route response, not an authentication, quota or transport error.
   A matched ROAD point is not evidence of a safe, legal path across land. */
function diagnosticRouteFailure(kind, status){
  try{ console.warn("Drive IQ route request:",kind,"HTTP",status || 0); }catch(e){}
}
function requestRouteVariant(wp,variant){
  return fetch(routeUrlForVariant(wp,variant)).then(function(res){
    if(!res) return {error:"network"};
    if(!res.ok){
      return res.text().then(function(body){
        var message = String(body || "").toLowerCase();
        var noRoute = (res.status === 400 || res.status === 404 || res.status === 422) &&
          /(?:no.route|route.not.found|could.not.find.route|cannot.find.route|no.path)/.test(message);
        diagnosticRouteFailure(noRoute ? "no-route" : "provider",res.status);
        return {error:noRoute ? "no-route" : "provider",status:res.status};
      }).catch(function(){ return {error:"provider",status:res.status}; });
    }
    return res.json().then(function(data){
      var feature = routeFeatureFromData(data,variant.kind);
      return feature ? {feature:feature,sourceKind:variant.kind} : {error:"no-route"};
    });
  }).catch(function(){diagnosticRouteFailure("network",0);return {error:"network"};});
}
function ruralRoadNotice(){
  if(!ruralRoadRecovery) return "";
  return "Road route starts " + fmtMiles(ruralRoadRecovery.distanceMiles) +
    " from GPS. Use a known legal access road; no off-road directions are provided.";
}
function recoverNearbyRoad(generation,variants){
  if(generation !== routeRequestGeneration || !lastFix || !dest) return Promise.resolve(null);
  var origin={lat:Number(lastFix.lat),lng:Number(lastFix.lng)};
  var target={lat:Number(dest.lat),lng:Number(dest.lng)};
  var key=getGeoapifyKey();
  var url="https://api.geoapify.com/v1/mapmatching?apiKey="+encodeURIComponent(key);
  setStatus("Checking nearby roads","blue");
  setSubline("Checking for a road-connected starting point...");
  return fetch(url,{
    method:"POST",headers:{"Content-Type":"application/json"},
    body:JSON.stringify({mode:"drive",waypoints:[{location:[origin.lng,origin.lat]}]})
  }).then(function(res){
    if(!res || !res.ok) return null;
    return res.json();
  }).then(function(data){
    if(generation !== routeRequestGeneration) return null;
    var f=data && data.features && data.features[0];
    var pts=f && f.properties && f.properties.waypoints;
    var pt=pts && pts[0];
    var xy=pt && pt.location;
    if(!pt || pt.match_type !== "matched" || !xy || xy.length<2) return null;
    var lng=Number(xy[0]),lat=Number(xy[1]);
    if(!finite(lat)||!finite(lng)||Math.abs(lat)>90||Math.abs(lng)>180) return null;
    var dist=miles(origin.lat,origin.lng,lat,lng);
    /* Conservative limit avoids showing a distant, unrelated route as accessible. */
    if(!finite(dist)||dist>0.5) return null;
    var wp=String(lat)+","+String(lng)+"|"+String(target.lat)+","+String(target.lng);
    return Promise.all(variants.map(function(v){return requestRouteVariant(wp,v);})).then(function(results){
      if(generation !== routeRequestGeneration) return null;
      var candidates=[],hasFailure=false;
      results.forEach(function(r){
        if(r && r.feature) candidates.push(r);
        else if(r && r.error && r.error!=="no-route") hasFailure=true;
      });
      if(!candidates.length) return {error:hasFailure ? "provider" : "no-route"};
      return {candidates:candidates,recovery:{lat:lat,lng:lng,distanceMiles:dist}};
    });
  }).catch(function(){return null;});
}
function routeNow(){
  var wp,generation,variants,originFix;
  if(!dest){setStatus("Need destination","gold");toast("Choose a destination first");return;}
  if(!lastFix){setStatus("Need GPS","gold");toast("Lock GPS first");requestGPS(true);return;}
  if(!getGeoapifyKey()){setStatus("Geoapify key missing","red");toast("Missing Geoapify key");return;}
  if(!lastFix.ts || Date.now()-Number(lastFix.ts)>120000){
    setStatus("Refresh GPS","gold");toast("Refresh GPS before routing");requestGPS(true);return;
  }
  wp=buildWaypoints();if(!wp)return;
  generation=++routeRequestGeneration;
  originFix={lat:lastFix.lat,lng:lastFix.lng};
  ruralRoadRecovery=null;
  routeOptions=[];selectedRouteIndex=0;hideRouteOptions();
  setStatus("Finding route options","blue");setMode("Route IQ");
  variants=[
    {kind:"balanced_traffic",type:"balanced",traffic:"approximated"},
    {kind:"balanced_free",type:"balanced",traffic:"free_flow"},
    {kind:"short",type:"short",traffic:"approximated"},
    {kind:"less_maneuvers",type:"less_maneuvers",traffic:"approximated"}
  ];
  Promise.all(variants.map(function(v){return requestRouteVariant(wp,v);})).then(function(results){
    if(generation!==routeRequestGeneration)return;
    var candidates=[],providerFailure=false;
    results.forEach(function(r){
      if(r&&r.feature)candidates.push(r);
      else if(r&&r.error&&r.error!=="no-route")providerFailure=true;
    });
    if(candidates.length){handleRouteOptions(candidates);return;}
    if(providerFailure){
      pendingStartAfterRoute=false;
      setStatus("Routing service issue","red");
      setSubline("Routing service unavailable or rejected the request. Try again later.");
      toast("Routing service issue");return;
    }
    recoverNearbyRoad(generation,variants).then(function(recovered){
      if(generation!==routeRequestGeneration)return;
      if(recovered&&recovered.candidates&&recovered.candidates.length){
        ruralRoadRecovery=recovered.recovery;
        /* No silent one-tap handoff when start is away from mapped roadway. */
        pendingStartAfterRoute=false;
        handleRouteOptions(recovered.candidates);
        setStatus("Road route found","gold");
        setSubline(ruralRoadNotice());
        toast("Nearby road route found");
      }else if(recovered&&recovered.error==="provider"){
        pendingStartAfterRoute=false;
        setStatus("Routing service issue","red");toast("Routing service issue");
      }else{
        pendingStartAfterRoute=false;
        setStatus("No safe road route confirmed","gold");
        setSubline("No nearby connected road confirmed. Use a known legal exit; do not cross fields or water.");
        toast("Road connection unavailable");
      }
    });
  }).catch(function(){
    if(generation!==routeRequestGeneration)return;
    pendingStartAfterRoute=false;
    setStatus("Routing service issue","red");toast("Routing service issue");
  });
}

function handleRouteOptions(candidates){
  var chosen;

  routeOptions = classifyRouteOptions(candidates || []);

  if(!routeOptions.length){
    pendingStartAfterRoute = false;
    setStatus("No route found","red");
    toast("No route found");
    return;
  }

  selectedRouteIndex = 0;
  chosen = routeOptions[0];

  routeGeo = routeFC(chosen.feature);
  routeReady = true;
  routeGeo.features[0].properties.driveIqIntel = chosen.intel;

  lsSetJSON(LS.ROUTE_GEO,routeGeo);
  lsSetJSON(LS.ROUTE_INTEL,chosen.intel);
  lsSet(LS.SELECTED_ROUTE_KIND,chosen.kind);

  /* Save compact option data for restoring the chooser on return. */
  try{
    lsSetJSON(LS.ROUTE_OPTIONS,routeOptions.map(function(opt){
      return {
        kind:opt.kind,
        feature:opt.feature,
        intel:opt.intel,
        sourceKind:opt.candidate && opt.candidate.sourceKind ? opt.candidate.sourceKind : ""
      };
    }));
  }catch(e){}

  drawRoute(routeGeo);
  updateRoutePanel(chosen.intel);
  renderRouteOptions();

  window.setTimeout(function(){ if(routeReady && routeGeo) fitRoute(true); },40);

  setStatus(routeOptions.length > 1 ? "Routes ready" : "Route ready","green");
  setSubline(routeOptions.length > 1
    ? String(routeOptions.length) + " routes available - choose your drive"
    : "Showing your route...");
  toast(routeOptions.length > 1
    ? String(routeOptions.length) + " route options found"
    : "Route found");

  if(pendingStartAfterRoute && !ruralRoadRecovery){
    window.setTimeout(function(){
      if(pendingStartAfterRoute && routeReady && routeGeo){
        commitStartDrive();
      }
    },120);
  }
}

function makeIntel(distanceMeters,durationSeconds){
  var mi = Math.round(Number(distanceMeters || 0) * 0.000621371 * 10) / 10;
  var score = 88;
  if(mi > 25) score -= 4;
  if(mi > 75) score -= 5;
  return { routeScore:score, durationLabel:fmtTime(durationSeconds), miles:mi, summary:"Score " + String(score) };
}
function updateRoutePanel(intel){
  var routeCard = document.querySelector(".diqRouteCard");
  var searchCard = document.querySelector(".diqSearchCard");

  if(!intel){
    setText("diqRouteScore","--");

    /* Current V24 shell */
    setText("diqRouteTitle", dest ? clean(dest.label || "Destination selected") : "Choose a destination");
    setText("diqRouteSub", dest
      ? "Destination selected. Find routes when you are ready."
      : "Your GPS pin, destination pin, and route will appear here.");

    /* Legacy shells retained for compatibility */
    setText("diqRouteScoreSub","Choose a destination");
    setText("diqArrivalIntel","--");
    setText("diqArrivalSub","Route not drawn yet");

    if(routeCard) routeCard.classList.remove("routeReady");
    if(searchCard) searchCard.classList.remove("routeActive");
    return;
  }

  setText("diqRouteScore",String(intel.routeScore));

  /* Current V24 shell */
  setText("diqRouteTitle", dest ? clean(dest.label || "Route ready") : "Route ready");

  var selectedOpt = routeOptions && routeOptions.length && routeOptions[selectedRouteIndex]
    ? routeOptions[selectedRouteIndex]
    : null;
  var selectedReason = selectedOpt ? routeOptionReason(selectedOpt.kind,selectedOpt) : "";

  setText(
    "diqRouteSub",
    String(intel.durationLabel) + " - " + String(intel.miles) + " mi" +
    (selectedReason ? " - " + selectedReason : "") +
    " - Ready to start"
  );

  /* Legacy shells retained for compatibility */
  setText("diqRouteScoreSub",String(intel.durationLabel) + " - " + String(intel.miles) + " mi");
  setText("diqArrivalIntel","Ready");
  setText("diqArrivalSub","Destination and route are loaded");

  if(routeCard) routeCard.classList.add("routeReady");
  if(searchCard) searchCard.classList.add("routeActive");
}

function restoreState(){
  var d = lsGetJSON(LS.DEST);
  var r = lsGetJSON(LS.ROUTE_GEO);
  var intel = lsGetJSON(LS.ROUTE_INTEL);
  var savedOptions = lsGetJSON(LS.ROUTE_OPTIONS);
  var selectedKind = clean(lsGet(LS.SELECTED_ROUTE_KIND) || "");
  var i;

  if(d && finite(Number(d.lat)) && finite(Number(d.lng))){
    dest = { label:d.label || "Destination", full:d.full || "", lat:Number(d.lat), lng:Number(d.lng), kind:d.kind || "destination", provider:d.provider || "", placeId:d.placeId || "" };
    if(byId("diqDestInput")) byId("diqDestInput").value = dest.label;
    drawDestPin();
  }

  routeOptions = [];
  if(savedOptions && savedOptions.length){
    for(i=0;i<savedOptions.length && i<4;i++){
      if(savedOptions[i] && savedOptions[i].feature){
        routeOptions.push({
          candidate:{sourceKind:savedOptions[i].sourceKind || ""},
          feature:savedOptions[i].feature,
          intel:savedOptions[i].intel || makeIntel(
            Number(savedOptions[i].feature.properties && savedOptions[i].feature.properties.distanceMeters || 0),
            Number(savedOptions[i].feature.properties && savedOptions[i].feature.properties.durationSeconds || 0)
          ),
          kind:savedOptions[i].kind || "alternate"
        });
      }
    }
  }

  selectedRouteIndex = 0;
  if(selectedKind && routeOptions.length){
    for(i=0;i<routeOptions.length;i++){
      if(routeOptions[i].kind === selectedKind){
        selectedRouteIndex = i;
        break;
      }
    }
  }

  if(r && r.features && r.features.length){
    routeGeo = r;
    routeReady = true;
    drawRoute(routeGeo);
    scheduleRouteOverviewFit();
  }

  if(routeOptions.length) renderRouteOptions();
  updateRoutePanel(intel || null);
}
function clearRoute(){
  routeOverviewGeneration += 1;
  routeOverviewLockUntil = 0;
  pendingStartAfterRoute = false;

  if(searchTimer){
    window.clearTimeout(searchTimer);
    searchTimer = null;
  }
  lastSearchRun = Date.now();
  dest = null;
  routeGeo = null;
  routeReady = false;
  clearRouteOptionPreview();
  routeOptions = [];
  selectedRouteIndex = 0;
  routeOptionsCollapsed = false;
  routeRequestGeneration += 1;
  ruralRoadRecovery = null;
  lsRemove(LS.DEST);
  lsRemove(LS.ROUTE_GEO);
  lsRemove(LS.ROUTE_INTEL);
  lsRemove(LS.ROUTE_OPTIONS);
  lsRemove(LS.SELECTED_ROUTE_KIND);
  hideRouteOptions();
  clearResults();
  clearRouteLine();
  clearDestPin();
  if(byId("diqDestInput")) byId("diqDestInput").value = "";
  updateRoutePanel(null);
  setMode("Drive IQ");
  setSubline("Search destination - Draw route - Start drive");
  setStatus("Ready","green");
  toast("Route cleared");
}
/* V24: evaluate the SAME persisted trip count used by Drive Mode ReviewIQ.
   Upgrade entitlement is a native-managed cached signal; localStorage alone
   is NOT secure purchase verification. Never strand a driver without navigation. */
var diqVerifiedWebPlus=false;
function diqVerifyWebPlus(){
  if(diqNativePurchaseAvailable()){return;}
  var token="";
  try{token=String(window.sessionStorage.getItem("diq_web_session_v1")||"");}catch(e){}
  if(!/^[a-zA-Z0-9_-]{32,200}$/.test(token)){return;}
  fetch("https://driveiq-subscription-api-85238371012.us-central1.run.app/v1/entitlement",{
    method:"GET",cache:"no-store",headers:{Authorization:"Bearer "+token}
  }).then(function(r){if(!r.ok)throw Error("verification_unavailable");return r.json();})
  .then(function(data){
    diqVerifiedWebPlus=!!(data&&data.active===true);
    if(diqVerifiedWebPlus){
      var cover=byId("diqFiveTripChoice");if(cover)cover.style.display="none";
      toast("Verified Drive IQ Web Plus is active.");
    }
  }).catch(function(){diqVerifiedWebPlus=false;});
}
function diqStartTier(){
  var count=Number(lsGet(LS.COMPLETED_TRIPS)||0);
  if(!finite(count)||count<0){count=0;}
  count=Math.floor(count);
  var plus=diqNativePurchaseAvailable()
    ? (lsGet(LS.PLUS_ACTIVE)==="1"||lsGet(LS.FOUNDING_DRIVER)==="1")
    : diqVerifiedWebPlus;
  return {tier:plus||count<5?"plus":"free",plus:plus,completed:count,remaining:Math.max(0,5-count)};
}
var diqFreeChoiceForAttempt=false;
/* V24B: Use the SAME direct Apple StoreKit purchase bridge used by the
   working home page. Do not trigger driveIQUpgrade's additional UIKit
   action sheet from within this five-trip overlay. */
function diqNativePurchaseAvailable(){
  try{
    if(window.DriveIQNative){return true;}
    var handlers=window.webkit&&window.webkit.messageHandlers;
    return !!(handlers&&(handlers.driveIQPurchase||handlers.driveIQUpgrade||handlers.driveIQDriving));
  }catch(e){return false;}
}
function diqStartPurchase(productId){
  var status=byId("diqFiveTripPurchaseStatus");
  var b1=byId("diqFiveTripMonthly"),b2=byId("diqFiveTripYearly");
  var id=String(productId||"com.loveforlocals.driveiq.plus.monthly");

  /* V27: Website subscriptions use verified Shopify checkout/activation.
     Native WKWebView continues using StoreKit unchanged. */
  if(!diqNativePurchaseAvailable()){
    if(status){status.textContent="Opening secure website subscription…";}
    window.location.assign("/pages/web-upgrades");
    return true;
  }

  if(status){status.textContent="Opening Apple's subscription confirmation…";}
  if(b1){b1.disabled=true;}
  if(b2){b2.disabled=true;}

  try{
    window.location.href=
      "driveiq://purchase?productId="+encodeURIComponent(id)+
      "&source=start_drive_five_trip_paywall";

    window.setTimeout(function(){
      if(b1){b1.disabled=false;}
      if(b2){b2.disabled=false;}
      if(status&&status.textContent.indexOf("Opening")===0){
        status.textContent="If the Apple sheet did not appear, tap the plan again.";
      }
    },3500);

    return true;
  }catch(e){
    if(b1){b1.disabled=false;}
    if(b2){b2.disabled=false;}
    if(status){status.textContent="Apple purchases could not open. Please try again.";}
    return false;
  }
}
function diqStartUpgrade(){
  var options=byId("diqFiveTripPlans");
  if(options){options.style.display="block";}
  var status=byId("diqFiveTripPurchaseStatus");
  if(status){status.textContent="Choose a Plus plan to continue.";}
  return true;
}
function diqShowFreeChoice(){
  var modal=byId("diqFiveTripChoice"),cover,box;
  if(!modal){
    cover=document.createElement("div");cover.id="diqFiveTripChoice";
    cover.setAttribute("role","dialog");cover.setAttribute("aria-modal","true");
    cover.setAttribute("aria-label","Choose Drive IQ Free or Plus");
    cover.style.cssText="position:fixed;inset:0;z-index:2147483000;background:rgba(1,7,14,.90);display:flex;align-items:center;justify-content:center;padding:22px;box-sizing:border-box";
    box=document.createElement("div");
    box.style.cssText="box-sizing:border-box;width:100%;max-width:440px;padding:26px;border:1px solid rgba(40,255,190,.36);border-radius:26px;background:#071723;color:#fff;font-family:system-ui,-apple-system,Arial;box-shadow:0 20px 80px rgba(0,0,0,.6)";
    box.innerHTML='<div style="font-size:11px;font-weight:900;letter-spacing:2px;color:#28ffbe">YOUR FIRST FIVE DRIVES</div>'+
      '<h2 style="font-size:28px;margin:13px 0">Keep driving with Drive IQ</h2>'+
      '<p style="font-size:15px;line-height:1.5;color:#d0e2e9">Your five full-feature drives are complete. You can keep basic GPS navigation, turn-by-turn guidance, voice directions and essential rerouting free.</p>'+
      '<button id="diqFiveTripUpgrade" type="button" style="width:100%;min-height:52px;margin-top:10px;border:0;border-radius:15px;background:linear-gradient(110deg,#28ffbe,#fff2a8);color:#03110d;font-size:16px;font-weight:900">Unlock Drive IQ Plus</button>'+
      '<div id="diqFiveTripPlans" style="display:none;margin-top:12px">'+
      '<button id="diqFiveTripMonthly" type="button" style="width:100%;min-height:48px;border:1px solid #28ffbe;border-radius:14px;background:#12332c;color:#fff;font-size:15px;font-weight:800">Plus Monthly — Continue with Apple</button>'+
      '<button id="diqFiveTripYearly" type="button" style="width:100%;min-height:48px;margin-top:9px;border:1px solid #28ffbe;border-radius:14px;background:#12332c;color:#fff;font-size:15px;font-weight:800">Plus Yearly — Continue with Apple</button>'+
      '<div id="diqFiveTripPurchaseStatus" role="status" style="min-height:15px;margin-top:10px;color:#bdd8d4;font-size:12px;line-height:1.4"></div></div>'+
      '<button id="diqFiveTripFree" type="button" style="width:100%;min-height:52px;margin-top:12px;border-radius:15px;border:1px solid #8db3bc;background:#12232e;color:#fff;font-size:16px;font-weight:800">Continue with Drive IQ Free</button>'+
      '<button id="diqFiveTripCancel" type="button" style="width:100%;margin-top:16px;border:0;background:transparent;color:#b1c4cc;padding:8px;font-size:13px">Not now</button>';
    cover.appendChild(box);document.body.appendChild(cover);modal=cover;
    byId("diqFiveTripUpgrade").onclick=function(){diqStartUpgrade();};
    byId("diqFiveTripMonthly").onclick=function(){diqStartPurchase("com.loveforlocals.driveiq.plus.monthly");};
    byId("diqFiveTripYearly").onclick=function(){diqStartPurchase("com.loveforlocals.driveiq.plus.yearly");};
    if(!diqNativePurchaseAvailable()){
      byId("diqFiveTripMonthly").textContent="Web Plus Monthly — Secure Checkout";
      byId("diqFiveTripYearly").style.display="none";
    }
    byId("diqFiveTripFree").onclick=function(){
      modal.style.display="none";diqFreeChoiceForAttempt=true;commitStartDrive();
    };
    byId("diqFiveTripCancel").onclick=function(){modal.style.display="none";};
    window.addEventListener("driveIQEntitlementChanged",function(e){
      var d=e&&e.detail||{};
      if(d.effectivePlus===true && d.status!=="promo_rejected"){
        lsSet(LS.PLUS_ACTIVE,"1");
        modal.style.display="none";
        toast("Drive IQ Plus is active. Tap Start Drive.");
      }
    },false);
  }
  modal.style.display="flex";
  try{byId("diqFiveTripFree").focus();}catch(e3){}
}
/* =====================================================================
   V25.8 WEB-ONLY APP STORE INVITATION
   Presentation gate only. Does not write route/trip state or modify Drive Mode.
   One impression per browser (localStorage; session fallback if unavailable).
   Never shown in native WKWebView, installed web app, or on Android.
   ===================================================================== */
var DIQ_APP_STORE_URL = "https://apps.apple.com/us/app/gps-navigation-drive-iq/id6770706972";
var DIQ_WEB_INVITE_KEY = "diq_web_app_invite_seen_v1";
var diqInviteSeenThisPage = false;
var diqInviteContinueOnce = false;
var diqInviteOpen = false;
var diqInvitePreviousFocus = null;

function diqIsWebIphone(){
  var ua = String(navigator.userAgent || "");
  if(!/iPhone|iPod/i.test(ua)) return false;
  if(!/Safari/i.test(ua)) return false;
  if(/CriOS|FxiOS|EdgiOS|OPiOS/i.test(ua)) return false; /* Safari only for conservative native-app exclusion. */
  if(window.navigator.standalone === true || window.matchMedia && window.matchMedia("(display-mode: standalone)").matches) return false;
  /* A native application hosting WKWebView should not receive website marketing interruptions. */
  if(window.webkit && window.webkit.messageHandlers && Object.keys(window.webkit.messageHandlers).length) return false;
  if(window.DriveIQNative || window.DRIVE_IQ_NATIVE || window.isDriveIQNative) return false;
  return true;
}
function diqInviteAlreadySeen(){
  if(diqInviteSeenThisPage) return true;
  try{if(localStorage.getItem(DIQ_WEB_INVITE_KEY)==="1") return true;}catch(e){}
  try{if(sessionStorage.getItem(DIQ_WEB_INVITE_KEY)==="1") return true;}catch(e2){}
  return false;
}
function diqMarkInviteSeen(){
  diqInviteSeenThisPage = true;
  try{localStorage.setItem(DIQ_WEB_INVITE_KEY,"1");}catch(e){}
  try{sessionStorage.setItem(DIQ_WEB_INVITE_KEY,"1");}catch(e2){}
}
function diqLogInviteEvent(eventName){
  /* Telemetry is best-effort, anonymous and never blocks route start. */
  try{
    var payload = JSON.stringify({app:"drive_iq",event_name:eventName,category:"engagement",surface:"start_drive_web",page:"start_drive",source:"start_drive_web_invite_v258",occurred_at:new Date().toISOString(),properties:{platform:"iphone_web"}});
    var api="https://drive-iq-founder-iq-api-85238371012.us-central1.run.app/events";
    if(window.fetch) window.fetch(api,{method:"POST",headers:{"Content-Type":"application/json"},body:payload,mode:"cors",keepalive:true,credentials:"omit"}).catch(function(){});
  }catch(e){}
}
function diqCloseInvite(){
  var overlay=byId("diqWebAppInvite");
  if(overlay && overlay.parentNode) overlay.parentNode.removeChild(overlay);
  document.removeEventListener("keydown",diqInviteKeys,false);
  diqInviteOpen=false;
  try{if(diqInvitePreviousFocus && diqInvitePreviousFocus.focus) diqInvitePreviousFocus.focus();}catch(e){}
}
function diqInviteKeys(e){
  if(!diqInviteOpen) return;
  if(e.key==="Escape"){e.preventDefault();diqDismissInvite();return;}
  if(e.key==="Tab"){
    var buttons=byId("diqWebAppInvite") ? byId("diqWebAppInvite").querySelectorAll("button,a") : [];
    if(!buttons.length) return;
    var first=buttons[0],last=buttons[buttons.length-1];
    if(e.shiftKey && document.activeElement===first){e.preventDefault();last.focus();}
    else if(!e.shiftKey && document.activeElement===last){e.preventDefault();first.focus();}
  }
}
function diqDismissInvite(){
  diqLogInviteEvent("app_download_prompt_dismissed");
  diqCloseInvite();
  /* Dismiss means return to route preview, not start navigation. */
}
function diqContinueWebAfterInvite(){
  diqLogInviteEvent("continued_on_web");
  diqCloseInvite();
  diqInviteContinueOnce=true;
  try{commitStartDrive();}finally{diqInviteContinueOnce=false;}
}
function diqShowWebInvite(){
  if(diqInviteOpen) return true;
  var overlay=document.createElement("div");
  overlay.id="diqWebAppInvite";
  overlay.setAttribute("role","dialog");
  overlay.setAttribute("aria-modal","true");
  overlay.setAttribute("aria-labelledby","diqWebAppInviteTitle");
  overlay.style.cssText="position:fixed;inset:0;z-index:2147483100;display:flex;align-items:center;justify-content:center;padding:18px;background:rgba(1,9,18,.87);backdrop-filter:blur(14px);-webkit-backdrop-filter:blur(14px);box-sizing:border-box";
  var card=document.createElement("div");
  card.style.cssText="box-sizing:border-box;position:relative;width:100%;max-width:390px;border:1px solid rgba(65,225,221,.38);border-radius:25px;padding:28px 22px 22px;background:linear-gradient(155deg,#102b36,#06121e 70%);box-shadow:0 24px 90px rgba(0,0,0,.7);color:white;text-align:center;font-family:system-ui,-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif";
  card.innerHTML='<button id="diqWebInviteClose" type="button" aria-label="Close invitation" style="position:absolute;right:13px;top:11px;border:0;background:transparent;color:#b7cbd5;font-size:28px;padding:3px 9px;cursor:pointer">×</button>'+
    '<div style="font-size:11px;letter-spacing:2px;font-weight:900;color:#56e1dc">YOUR ROUTE IS READY</div>'+
    '<div style="font-size:37px;margin:13px 0 5px" aria-hidden="true">📱</div>'+
    '<h2 id="diqWebAppInviteTitle" style="font-size:27px;line-height:1.16;letter-spacing:-.5px;margin:8px 0 11px;color:#fff">Take Drive IQ on the road</h2>'+
    '<p style="font-size:14px;line-height:1.55;color:#c5dbe3;margin:0 0 20px">Get the iPhone app for Apple CarPlay, personalized driving displays, and convenient everyday navigation.</p>'+
    '<a id="diqWebInviteDownload" href="'+DIQ_APP_STORE_URL+'" rel="noopener noreferrer" style="display:block;border-radius:15px;min-height:53px;line-height:53px;text-decoration:none;text-align:center;background:linear-gradient(110deg,#53e3dc,#b9fff2);color:#05202a;font-weight:900;font-size:16px">Download on the App Store ↗</a>'+
    '<button id="diqWebInviteContinue" type="button" style="display:block;width:100%;margin-top:12px;min-height:50px;border:1px solid rgba(185,231,238,.43);background:rgba(255,255,255,.055);color:#fff;border-radius:14px;font-size:15px;font-weight:800;cursor:pointer">Continue on Web</button>'+
    '<p style="margin:13px 0 0;color:#92aeb9;font-size:11px">Free to download · Web navigation remains available</p>';
  overlay.appendChild(card);
  diqInvitePreviousFocus=document.activeElement;
  document.body.appendChild(overlay);
  diqInviteOpen=true;
  diqMarkInviteSeen();
  diqLogInviteEvent("app_download_prompt_shown");
  byId("diqWebInviteClose").onclick=diqDismissInvite;
  byId("diqWebInviteContinue").onclick=diqContinueWebAfterInvite;
  byId("diqWebInviteDownload").onclick=function(){diqLogInviteEvent("app_store_button_clicked");};
  overlay.onclick=function(e){if(e.target===overlay) diqDismissInvite();};
  document.addEventListener("keydown",diqInviteKeys,false);
  try{byId("diqWebInviteDownload").focus();}catch(e){}
  return true;
}

function commitStartDrive(){
  var driveId,access;
  if(!dest || !routeReady || !routeGeo) return false;
  if(ruralRoadRecovery){
    var nearby=miles(lastFix.lat,lastFix.lng,ruralRoadRecovery.lat,ruralRoadRecovery.lng);
    if(nearby>0.05){
      setStatus("Reach road before guidance","gold");
      setSubline(ruralRoadNotice());
      toast("Get to the road via known legal access first");
      return false;
    }
  }
  /* Only show after route is valid and the existing rural-road safety guard passes.
     Never mutate route/session data while this invitation is open. */
  if(!diqInviteContinueOnce && !diqInviteOpen && diqIsWebIphone() && !diqInviteAlreadySeen()){
    diqShowWebInvite();
    return false;
  }
  if(diqInviteOpen) return false;
  access=diqStartTier();
  if(access.tier==="free"&&!diqFreeChoiceForAttempt){diqShowFreeChoice();return false;}
  diqFreeChoiceForAttempt=false;
  lsSet(LS.ACCESS_TIER,access.tier);

  pendingStartAfterRoute = false;
  routeOverviewGeneration += 1;
  routeOverviewLockUntil = 0;

  driveId = "diq_" + String(Date.now());
  lsSet(LS.ACTIVE_DRIVE_ID,driveId);
  lsSet(LS.DRIVE_ON,"1");
  /* Re-read the Garage selection at the actual handoff, not just at boot. */
  applyStartDriveSkin(readSkin(),"drive-mode-handoff");
  lsSetJSON(LS.DRIVE_PAYLOAD,{
    drive_id:driveId,
    skin:activeSkin,
    theme:activeSkin,
    access_tier:access.tier,
    completed_full_feature_trips:access.completed,
    destination:dest,
    route:routeGeo,
    route_intel:lsGetJSON(LS.ROUTE_INTEL),
    started_at:new Date().toISOString()
  });

  setStatus("Opening Drive Mode","green");
  window.setTimeout(function(){ window.location.href = DRIVE_MODE_URL; }, 250);
  return true;
}

function startDrive(){
  routeOverviewGeneration += 1;
  routeOverviewLockUntil = 0;

  if(!dest){
    toast("Choose a destination first");
    return;
  }

  /* V13 ONE-TAP START:
     If a destination is selected but the route has not finished drawing,
     remember the driver's intent and automatically enter Drive Mode as soon
     as routing succeeds. No second START DRIVE tap required. */
  if(!routeReady || !routeGeo){
    pendingStartAfterRoute = true;
    toast("Building route...");
    routeNow();
    return;
  }

  commitStartDrive();
}

function bindButtons(){
  var input = byId("diqDestInput");
  if(input){
    input.addEventListener("input", function(){
      var q = clean(input.value);
      if(searchTimer) window.clearTimeout(searchTimer);
      searchTimer = window.setTimeout(function(){ geocode(q); }, 260);
    }, false);
    input.addEventListener("keydown", function(e){
      var box = byId("diqResults");
      var first;
      if(e && e.key === "Enter"){
        first = box && box.__items && box.__items.length ? box.__items[0] : null;
        if(first){ e.preventDefault(); chooseDestination(first); }
      }
    }, false);
  }
  if(byId("diqLockGps")) byId("diqLockGps").onclick = function(){ requestGPS(true); };
  if(byId("diqCenterRoute")) byId("diqCenterRoute").onclick = function(){ if(routeReady && routeGeo){ fitRoute(); } else if(lastFix){ flyTo(lastFix.lng,lastFix.lat,15.3); } };
  if(byId("diqCenter")) byId("diqCenter").onclick = function(){ if(routeReady && routeGeo){ fitRoute(); } else if(lastFix){ flyTo(lastFix.lng,lastFix.lat,15.3); } };
  if(byId("diqCenterMap")) byId("diqCenterMap").onclick = function(){ if(routeReady && routeGeo){ fitRoute(); } else if(lastFix){ flyTo(lastFix.lng,lastFix.lat,15.3); } };
  if(byId("diqRouteNow")) byId("diqRouteNow").onclick = routeNow;

  if(byId("diqRouteOptionsList")){
    byId("diqRouteOptionsList").onclick = function(e){
      var node = e && e.target ? e.target : null;
      var idx = null;

      while(node && node !== this){
        if(node.getAttribute && node.getAttribute("data-route-index") !== null){
          idx = Number(node.getAttribute("data-route-index"));
          break;
        }
        node = node.parentNode;
      }

      if(idx !== null && finite(idx)){
        selectRouteOption(idx,true);
      }
    };
  }

  if(byId("diqClearRoute")) byId("diqClearRoute").onclick = clearRoute;
  if(byId("diqModifyRoute")) byId("diqModifyRoute").onclick = function(){
    clearRoute();
    var modifyInput = byId("diqDestInput");
    if(modifyInput){ try{ modifyInput.focus(); }catch(e3){} }
  };

  /* Visible X in the current Start Drive shell. */
  if(byId("diqV111ClearDestination")){
    byId("diqV111ClearDestination").onclick = function(e){
      if(e && e.preventDefault) e.preventDefault();
      if(e && e.stopPropagation) e.stopPropagation();

      if(searchTimer){
        window.clearTimeout(searchTimer);
        searchTimer = null;
      }

      /* Invalidate any in-flight search so stale results cannot reappear. */
      lastSearchRun = Date.now();
      clearRoute();

      var inputNow = byId("diqDestInput");
      if(inputNow){
        inputNow.value = "";
        try{ inputNow.focus(); }catch(e2){}
      }
    };
  }

  if(byId("diqStartDrive")) byId("diqStartDrive").onclick = startDrive;
  if(byId("diqZoomIn")) byId("diqZoomIn").onclick = function(){ if(map) map.zoomIn(); };
  if(byId("diqZoomOut")) byId("diqZoomOut").onclick = function(){ if(map) map.zoomOut(); };
  window.addEventListener("resize", function(){ ensureMapSize(); if(routeReady && routeGeo){ window.setTimeout(function(){ if(routeReady && routeGeo) fitRoute(false); },120); } }, false);
}


/* ---------------------------------------------------------------------
   V14 CUSTOM GEOGRAPHIC LABEL AUTHORITY
   Presentation-only. Does not touch routing, GPS, camera authority,
   maneuver logic, street names, or Drive Mode handoff.
--------------------------------------------------------------------- */

/* ---------------------------------------------------------------------
   V15 BASE-MAP LABEL CLEANUP
   Hide only Mapbox's "Gulf of Mexico" label so Drive IQ's custom
   "Gulf of America" label is the single visible authority.
--------------------------------------------------------------------- */
function suppressLegacyGulfLabel(){
  var style, layers, i, layer, existing, nameFilter;

  if(!mapLoaded || !map || typeof map.getStyle !== "function") return;

  try{
    style = map.getStyle();
    layers = style && style.layers ? style.layers : [];

    nameFilter = [
      "all",
      ["!=", ["coalesce", ["get","name_en"], ["get","name"], ""], "Gulf of Mexico"],
      ["!=", ["coalesce", ["get","name_en"], ["get","name"], ""], "Golfo de México"],
      ["!=", ["coalesce", ["get","name_en"], ["get","name"], ""], "Golfo de Mexico"]
    ];

    for(i=0;i<layers.length;i++){
      layer = layers[i];
      if(!layer || layer.type !== "symbol") continue;

      /*
        Only touch text-bearing symbol layers. Preserve any existing filter by
        wrapping it in an "all" expression with our single-name exclusion.
      */
      if(!layer.layout || !layer.layout["text-field"]) continue;

      try{
        existing = typeof map.getFilter === "function" ? map.getFilter(layer.id) : null;

        if(existing){
          map.setFilter(layer.id, ["all", existing, nameFilter]);
        }else{
          map.setFilter(layer.id, nameFilter);
        }
      }catch(eLayer){}
    }
  }catch(e){}
}

function ensureDriveIqCustomGeographyLabels(){
  var sourceId = "diq-custom-geography-src";
  var gulfLayerId = "diq-custom-geography-gulf";
  var lakeLayerId = "diq-custom-geography-lake";
  var data;

  if(!mapLoaded || !map) return;

  data = {
    type:"FeatureCollection",
    features:[
      {
        type:"Feature",
        properties:{ name:"Gulf of America", kind:"gulf" },
        geometry:{ type:"Point", coordinates:[-90.20,25.65] }
      },
      {
        type:"Feature",
        properties:{ name:"Lake America", kind:"lake" },
        geometry:{ type:"Point", coordinates:[-87.15,44.15] }
      }
    ]
  };

  try{
    if(!map.getSource(sourceId)){
      map.addSource(sourceId,{ type:"geojson", data:data });
    }else{
      map.getSource(sourceId).setData(data);
    }

    if(!map.getLayer(gulfLayerId)){
      map.addLayer({
        id:gulfLayerId,
        type:"symbol",
        source:sourceId,
        minzoom:2.4,
        maxzoom:8.2,
        filter:["==",["get","kind"],"gulf"],
        layout:{
          "text-field":["get","name"],
          "text-font":["Open Sans Semibold","Arial Unicode MS Regular"],
          "text-size":[
            "interpolate",["linear"],["zoom"],
            2.4,14,
            4.0,18,
            6.0,22,
            8.2,26
          ],
          "text-letter-spacing":0.08,
          "text-allow-overlap":true,
          "text-ignore-placement":true
        },
        paint:{
          "text-color":"#d9e6ee",
          "text-halo-color":"rgba(12,27,38,0.92)",
          "text-halo-width":2.6,
          "text-halo-blur":0.5
        }
      });
    }

    if(!map.getLayer(lakeLayerId)){
      map.addLayer({
        id:lakeLayerId,
        type:"symbol",
        source:sourceId,
        minzoom:2.4,
        maxzoom:8.2,
        filter:["==",["get","kind"],"lake"],
        layout:{
          "text-field":["get","name"],
          "text-font":["Open Sans Semibold","Arial Unicode MS Regular"],
          "text-size":[
            "interpolate",["linear"],["zoom"],
            2.4,11,
            4.0,14,
            6.0,17,
            8.2,20
          ],
          "text-letter-spacing":0.07,
          "text-allow-overlap":true,
          "text-ignore-placement":true
        },
        paint:{
          "text-color":"#d9e6ee",
          "text-halo-color":"rgba(12,27,38,0.92)",
          "text-halo-width":2.2,
          "text-halo-blur":0.5
        }
      });
    }

    if(map.getLayer(gulfLayerId)) map.moveLayer(gulfLayerId);
    if(map.getLayer(lakeLayerId)) map.moveLayer(lakeLayerId);

  }catch(e){}
}

function initMap(){
  var token = getMapboxToken();
  var container = byId("diqMap");
  if(!container){ setStatus("Map container missing","red"); return; }
  ensureMapSize();
  if(!window.mapboxgl){ setStatus("Mapbox GL missing","red"); toast("Load Mapbox GL CSS/JS before this file"); return; }
  if(!token){ setStatus("Mapbox token missing","red"); toast("Missing Mapbox token"); return; }
  try{
    mapboxgl.accessToken = token;
    map = new mapboxgl.Map({
      container:"diqMap",
      style:"mapbox://styles/mapbox/navigation-night-v1",
      center:[-89.987,35.149],
      zoom:10.5,
      pitch:0,
      bearing:0,
      attributionControl:false
    });
    window.DRIVE_IQ_START_MAP = map;
    map.on("load", function(){
      mapLoaded = true;
      ensureMapSize();
      ensureGpsSource();
      paintStartDriveMapTheme();
      suppressLegacyGulfLabel();
      ensureDriveIqCustomGeographyLabels();
      setStatus("Map ready","green");
      setGps("GPS: --");
      restoreState();
      restoreGPS(false);
      toast("Map ready");
      window.setTimeout(ensureMapSize, 250);
      window.setTimeout(ensureMapSize, 900);
      window.setTimeout(function(){ if(routeReady && routeGeo) scheduleRouteOverviewFit(); },320);
    });
    map.on("styledata", function(){
      if(mapLoaded){
        window.setTimeout(function(){ paintStartDriveMapTheme(); },0);
      }
    });
    map.on("error", function(){ setStatus("Map warning","gold"); });
  }catch(e){
    setStatus("Map failed","red");
    toast("Map failed");
  }
}

function boot(){
  document.body.setAttribute("data-diq-js","v20-route-explanations");
  diqVerifyWebPlus();
  startThemeAuthority();
  bindButtons();
  initMap();
  ensureGooglePlaces();
  setMode("Drive IQ");
  setSubline("Search destination - Draw route - Start drive");
}

if(document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot, false);
else boot();

})();
